var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _rect, _b, _b2, _b3, _text, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _rect2, _b4, _text2, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _rect3, _b5, _text3, _g130, _g131, _rect4, _b6, _text4, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _rect5, _b7, _text5, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _rect6, _title, _text6, _rect7, _title2, _text7, _g195, _rect8, _title3, _text8, _rect9, _title4, _text9, _rect10, _title5, _text10, _g196, _rect11, _title6, _text11, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _rect12, _title7, _text12, _rect13, _title8, _text13, _g219, _g220, _g221, _g222, _rect14, _title9, _text14, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _rect15, _title10, _text15, _rect16, _title11, _text16, _g240, _g241, _g242, _g243, _rect17, _title12, _text17, _g244, _g245, _rect18, _b8, _text18, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _rect19, _title13, _text19, _rect20, _title14, _text20, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _rect21, _b9, _text21, _rect22, _text22, _rect23, _text23, _g280, _g281, _rect24, _b10, _text24, _g282, _rect25, _br, _text25, _g283, _g284, _rect26, _b11, _b12, _b13, _text26, _rect27, _br2, _text27, _rect28, _br3, _text28, _rect29, _text29, _rect30, _text30, _g285, _rect31, _text31, _rect32, _text32, _g286, _rect33, _br4, _text33, _rect34, _br5, _text34, _rect35, _text35, _rect36, _text36, _g287, _rect37, _text37, _rect38, _text38, _g288, _rect39, _br6, _text39, _rect40, _br7, _text40, _g289, _rect41, _br8, _text41, _g290, _rect42, _br9, _text42, _rect43, _text43, _g291, _g292, _rect44, _br10, _br11, _br12, _br13, _br14, _br15, _br16, _br17, _br18, _br19, _br20, _br21, _br22, _text44, _g293, _rect45, _title15, _text45, _rect46, _title16, _text46, _rect47, _title17, _text47, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _rect48, _title18, _text48, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _g310, _g311, _g312, _g313, _g314, _g315, _g316, _g317, _g318, _g319, _g320, _g321, _g322, _g323, _g324, _g325, _g326, _g327, _g328, _g329, _g330, _g331, _g332, _g333, _g334, _g335, _g336, _g337, _g338, _g339, _g340, _g341, _g342, _g343, _g344, _g345, _g346, _g347, _g348, _g349, _g350, _g351, _g352, _g353, _g354, _g355, _g356, _g357, _g358, _g359, _g360, _g361, _g362, _g363, _g364, _g365, _g366, _g367, _g368, _g369, _g370, _g371, _g372, _g373, _g374, _g375, _g376, _g377, _g378, _g379, _g380, _g381, _g382, _g383, _g384, _g385, _g386, _g387, _g388, _g389, _g390, _g391, _g392, _g393, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentTestdrawio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "2171px",
    height: "1542px",
    viewBox: "-0.5 -0.5 2171 1542",
    content: "<mxfile host=\"embed.diagrams.net\" modified=\"2023-06-12T07:01:33.739Z\" agent=\"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/108.0.0.0 Safari/537.36\" etag=\"pSCjzs3HCSUS0Yve_gZz\" compressed=\"true\" version=\"21.3.8\" type=\"embed\"><diagram name=\"Page-1\" id=\"K3BbFDBLqoid1fIjtWqK\">7Z1bd+K40oZ/TdaafQHLls+XOSfdnT6R6Un3zSwHnOAOAdqQ0/z6bRsMPggsjCSb8Ob71uyOQ0Sw631UqiqVDrTjx9fzwB33r0Y9b3BAlN7rgXZyQIiqKEb4P9GVt9kVopjq7Mp94Pfmr1pe6Pj/ecmvzq8++T1vknnhdDQaTP1x9mJ3NBx63WnmmhsEo5fsy+5Gg+y7jt37+TsqywudrjvwCi/7x+9N+7OrNrGW1y88/76fvLNqOrOfPLrJi+cDT/pub/SSuqSdHmjHwWg0nf3r8fXYG0R3L7kvd4+d8fXw0vjy9PH4x5vXuXT8X63ZYGeb/MriIwTecMo69Oj2d3Q7iTJwb8NnGv/WbJynoT+d39T+/OG6U3d2ofcUuFN/NJxdH4bmcP02nt/J8AlNXX/oBbMfJn/yt/Hl2+nvjnvef3i4Oe+Yfv/qqkWcxQ1afMbJ9C15KMHoadjzogGUA+3ope9Pvc7Y7UY/fQntMLx2P3Ank/nP409w5HYf7uPfOx4NRkE8jnYWfy1eMgp6XpD8uOfduU+D8H4dTR68abc/H2w88odTLzh9Du9l9AZq9IJpMHrwUuMex1+LnySGE732LrwLZ+6jP4gEceENnr2p33XnP5ibv5q8sPi33PmDQXJ1OBp60UcN3J7vLV88v7y83bM37o4GA3c88W/jmxh9lMDrPgUT/9n77k1mbxxdDRXsTd3Zq6Lf608fB4shYo2lfugOBqOXw0Rm0ZXH0XPq50E0cur77iD849zUnzCauunxvJ6f/nY4+jS3vui7njvpxw89vueJmqJhGA18LoRnL5h6CaFSdnbujR69afAWviT5qaHPxTvHV0tVbKftmLOLL0sgqMkL+2kY6Nryxe5cM/eLd1mKLfzH3MyTb+fyy0pxPAhtvB8SzJvZGXl2B0/e/EPF/8wga/nqLAOzskwk+zm8muFrWvMpCKgM8rW0tfINn1387pOpN+z6g7+mP66n16Orl7ML4oaf/ffNN3/0EP7j5J+AnA+I8fvD049B0Dm7vTad8be/e+bV4c+B/3bVJdaz3j1xLo/ftLN/DsjRofLxm299+PHt0Xc/PGtj+/Hx7On89fDpoa9ob1+7nZ+Tb+ZId15eJpefz//c/7n68tv8eDH5/fZzEr5f+AjPnJ+fgu+dm/uOOhl/vfzRe/vU/fEtHPrzf4OLiXfxOngZ/Hm+0D+fTF7vr4KPp8/PTs/xz63f2pH5wXKuSe/CMYamdmro5vWT8+PpipxG44b//2kyfflvavy5NW4mT7/vvd//qDe26/86vT5xum9K9Kqh/dt4vbj8/enCOnw7Nn4+/3N+abh/k8mXY+X78fD39NixifP3yfjHz6fzr/8Euv38fKmSp38+OH/b/WDw6n3tf/Cvn75d3N7//fVEvft4Pvjct87DoY2jzx/Pv379dBV+GG8QXPWGZ1q3d/7ZVYcXv8Jrg7vLl/Hj5IfXn3z72rH86aPy+/jrw+m9/efv+w9/a+rTkfXH0s9HU//mY3RDjMPLP5++TV56gfLpTv32Mrm4+BAq8ejy+n8roJyVcxplITOPTk6Us2MaTc1j+/RoQemvo4kfTzHaSdeLUBz+IFJ0SNHBp9wLpqNxDCn/nvryw/kPZi+bhH+sP7wPvycR9kaB/1+E0OTPnf/4OnrtiaqvnleWsF47q6R5r0uBa57sOdgW56oSxq6ZuTeCbBaxKnHaVug4Lr70ImwJBbaaIpuzRChnCQtndXAWnAVnwVkGzjpZzJq7gtkGuLMGMAvMArPA7OburKnQ4wXNYKsmlK0aC1tNsBVsBVvB1s3ZaphNZmsDwgMW2Aq2gq1gawW2kiaztQF+6/oMNdgKtoKtYCuVrboesXUXYq/1+7C2As6Cs+AsOLtxiktXdgWz9buztgrMArPALDC7uTtLFJQSsJYS2AScBWfBWXB2c85qJvxZZn8WOxDAWXAWnK3CWbIrnG1AeBY7EMBZcBacZeFsNjxL7F3BbAPCBtiBAMwCs8BsBXeW6AjPsnLWssFZcBacBWc3rzaAO8vuzmLTFzALzAKzm2PWavS+hAYEZLHnC2gFWoHWCpECq9H7aRtQVIDoANgKtoKtFdhqN7oPTAP8VuynBVvBVrC1AltNvclsrd9vdbCHFmwFW8HWKmxdcd5BM9iqC2WrzsJWbJwFWzdk69nZkWaaNLaeKlGljkC2Pvq9XmSbdeKV7ABelycMqfJyW7bRZNYaQllrsLCWgLVgLVgL1vI4Z0ZpdES2AZ4tttCCtqAtaMvjtBkFru162GIfLWAL2AK2PGCrwrNdD1tsPwBsAVvAlgNsHTi261mLzgVgLVgL1vJgbaP92gawFnu/wFqwFqzlEUQgWpNhW38PAwebwQBbFNWiqJaFrfnaA7XRUQPSErtnYTH+esBiRxgAC8ACsBWcV9UBX8v4Gi3uAFgAFoAFYDf3YInVZMIeEPM+enxiOZt7lxLaYqMYaAvagrZVaKvV0/Uww7pozKehP02GnV3phbdzdmEceNeB6w8je6HAtRsZjj8MjS0DS2Ny1v/xu//WOvxx+vf30Z/j03/91nrHdBkPV1aI6n7gTibzn6+wyDj1EX2V2eTkwZt2+/PBxiM/0svpc/jAJxkbSY17HH9RrScy8DP30R9ED/bCGzx7kehylp+8kKKPFB6GoWFHHzVwe763fPH88vJuz3UwGgzc8cRPKcHrPgUT/9n7HkkmuZrXQ3/6OFgMIVqMOfH13El/kfYo0d3dY2d8Pbw0vjx9PP7x5nUuHf9XS91YdqaTE56ttBU91dSZFDVoUjSoWluLcGH5a5WiU1wfkvMsClaYeqiJ2/H4GhrSuN++C59ot+8G07Y7HEaPJ5w0/lVTE8bAu5uuEEI2T1WQxRkxT0w7a+tOztTDl83uc3EuPDs8cU6M1Rbf80OLns9xnjuJpTt0x9ejr9GfOjec+ieU9Wa8moYbmbGWNWLFaCupzuTJj1NGTJtH9M1NeFM3XdnMPQ9v9FrXPFHKqedp097orTcJ/iaOY9yckosWQbQD/vemxREJc1bDDP63ZP+7wPQFUunVEXyQSrJ+QeiNG87yS21sIEQqYRHhAGFBWBCWB2GjAon0l2oAsSFiCRALxAKxQCwHxKqq0lbSbqwswhZCW4e9l5/jX+bT3e2XV13rfDz/99OHFpkdZYPgFoJba4JbhtFOhWcVVRUV22I1WhNGC6MtMVo9Ez6wzWL4gHdAdqNMXs/1B2/X4W0cfPfCx7ZlMk9d320B2Txk88Rk84hmZB0eEmfzil6OThHb9gm8Jq8j0bUa68hN15G3btfuaTREEk3XjR7WkQ1YR8Z/9FzIGdBusK5MshmVy5WctmOnnXJK0USjCpdGkymvyqX13U7g68DXEeTrKFouuFNf5VKTHR8Nu7bh+CCA/v4cnyqOjrE5ZbOxR6dtpx0dS7qf00TCYts2CAvCgrA8CBt3MracGnKUjUYs+rwBsUAsEMsDsc3fWLhMR24bnVPXn7KB8BzCc4LCc0QppCKLotu/PKSJM8bgycCTgSeznJ23OWSsraippaIif7FY4tecPUT/6a12cDast1pRgrg+AgcvpxYvJ+N0SHd56im4aqmKw+jnqJqAlgnPHf1G8R2r9St4+3rf+XX4EnxpqQ5D0wRv2IsfRjQbRGrwu9mnWVJZe6pYh8bZQaGUVnO0Y8OkzGnk+Ng+o5J0vRlsiO6i3RVFVrSOdZghite799ZaR+rRG5Qnn1wLvIE7DQWVcTZpxjB/h9lNWhif6bQtNWN9ttK2jFR6Rs8OORk9BV1vPsrSxBgGjjZOrBt56gb33rQwcmy8i/vCVGNONeBFNXG24VmMuNukJ1k8nXiTaJ7x3cAfRf/6K3lV+LaLFxZ+MzSx6Sj6PS/6z8GxdnB4En4yll/9H/1VZNUEpK6YgFJC26wI7YQqofo9pjR9t1dc5cIsLbJbNqfI2JzGTV5oOgQLTSw0UfD67haaGxa8cgOr2jayPoGmUTzd/ctNOojoAbQALUArDLTU1MkegnZ9LhOgBWgBWoC2eoN/BZiNMIvzq4FZYBaYFYTZxSa8Pcfs+iYhwCwwC8wCs1uEDVQVoI1Ai70jAC1AC9AKA61iOMxVBu+ctWg2AdaCtWCtoNiBApc2xiw6TgCzwCwwKwazDiK0EWXVWT4QmAVmgVlglj9m4czOMIvW3MAsMAvMisGsDW92hlkCzAKzwCwwKygPZsOfnYEWG8IAWoAWoBUFWssCaGPQYkMYQAvQArTCQIsOBzPQYksYQAvQArRiIrQmrWXiPmIWW8KAWWAWmBWEWQOYjTGLDWHALDALzArCLNJgM8xiLxgwC8wCs2IwayAJNsMs9oIBs8AsMCsIs0iBxZhVsRcMmAVmgVkxmNWRApthFnvBgFlgFpgVhFmkwGaYJcAsMAvMArNiMIsU2Ayz2AkGzAKzwKygw22RApthFvvAgFlgFpgVhFmkwGaYxS4wYBaYBWbFYJYgBTbDLHaBAbPALDArCLNIgc0wi11gwCwwC8wKwixSYDPMYhcYMAvMArOCTgRDCmyGWewCA2aBWWBWEGb3LgXmf74yX07OrP719OroZkh+Xl20WijnAmQBWUBWEGSJLp+yg7npLgD4NPSnybDhLz3czy5H4EwQ6g/erkeRCVEA242Myx+GBpnBKf2WlXTiiu3P680fEk169wN3Mpn/fIXdhko7i7/KLHfy4E27/flg48g6vOD0OXzok4wlpcY9jr+oNhZZ1Jn7GN6p8MKFN3j2Imnm9JG8kKKiFESGoflHHzVwe763fPH88vJ+z9UyGgzc8cRP6cXrPgUT/9n7HgkruZpXTX/6mCCh50768V1Xpeg3r9dEewpVe3ePnfH18NL48vTx+Meb17l0/F8tdVPlhW5DVntRHw2K+HSK+NRF2eXOOznUtaSJLZjwcjb0cs4OT5wTg8bIM2KemDa8nAZ4OZW8mtkUvVkX/ZxXY+/b2pGOVQKsAqvAKrDKB6uoSp9hFXt/gFVgdeexWhNEwdCIodjYA4aCoWBoJYaiAidmKHbtgKFgKBhahaEoFp8xFFtywFAwFAytxFDsa4wZiv02YCgYuvMMbUiaCU05ZlTF9hpQFVQFVflQFbn7mKqzyDGoCqqCqqDq9lRFJiqmKur3QVVQFVTlQ1Wc5TGjKsr3QVVQFVTlRFVkq2KqoqMGqAqqgqqcqIpsVUxV7IkCVUFVUJUPVQ1kq2KqYpcUqAqqgqqcqIpsVUxV7JsCVUFVUJUPVU1kq2KqYicVqAqqgqqcqIpsVUxV7K0CVUFVUJUTVZGtiqmKvVWgKqgKqvKhqoVsVURVG3urQFVQFVTlRFVkq2KqYm8VqAqqgqp8qGojWxVTlYCqoCqoCqry6UitmsBqhFVsrgJWgVVglddBfgqwGmEVu6uAVWAVWK2IVScbAoCvGkMV2wAAVUAVUOUCVQdx1Riq2AUAqAKqgCofqMJTjaGKTQCAKqAKqHKBqqrAVY2pik0AoCqoCqpyoip81YiqDjYBgKqgKqjKq7BKnrO64FUCuNuH527r24PqvPpDy/vx75+j1l1LJXYBsAfEjB/sbfiP++gf1+H9H3ghWJSe7wb+KPrXX72DY+3g8MSNL4d4VcKbF97A0f8Wvx4kv59cCf/C2+U1kmVpbHpeb/5IaKrrTx+rS65oAvXbaWKDCtVoZc31rNv9jM1Nks0Gk4k7Y4I56/CGvfjBRPQbuJOJ380aRNZ6VptBBKvUdc3Rjg2TYlDk+Ng+o5rNepPY0ASKNri9HXi9e2+tFaQetLHmOQfewJ36z+mx6A9//g6zm7QwMtNuW6qy/NIzRmfnjGkyegq63nyIpT1tOOoCr8mwUze496aFYWMzXdwRmuU2xCn1P1+ZLydnVv96enV0MyQ/ry5aLWyhgk8KnxQ+Ka+qVF3+Un8wN9UF8J6G/jQZNvylh/vZ5QiUs6vj0WR6Hbj+MLIiClK7kTn5w9AEMwCl3jRVX9+JeulMKCvEdh/5IPOfr7DUSFvxV5mtTh68abc/H2wc2YMXnD6Hj31ysMKbOY6/qFYVGf6Z++gPoqd74Q2evUiMOUUkL6ToJoWNYWjw0UcN3J7vLV88v7y834knMxi444mfUojXfQomoQPxPZJScjWvk5QP13Mn/YULJ16x67zxovruHjvj6+Gl8eXp4/GPN69z6fi/Wuqm2iNKIqK5+lqqQmtiZFLkpxLrXcfadMTa4NfAr9l5v6aCFzOfkDfyYuycF+O0LUO6H9NEjGJ5CIwCo8BoJYyawOgcowQYBUaBUWC0AkaJAozOMYoWGsAoMAqMVsKoDozOMYqWGcAoMLrzGOWS8+UAVhtgnYMVZxIDrAArwMoHrBrSUAlY0Y8IYAVYAVZOYEViKgErehIBrAArwMoHrDpSVQlY0ZcIYAVYAVZOYEXyKgErWhMBrAArwMoJrEhezcFqYMcUwAqwAqx8wGogeZWAFXuoAFaAFWDlBFYkrxKwEoAVYAVYAVYuYDWRvErAin1WACvACrByAiuSVwlYsfMKYAVYAVZOYEXyKgErdl4BrAArwMoHrBaSVwlYsfMKYAVYAVZOYEXyKgErdl4BrAArwMoHrDaSVwlYsfMKYAVYAVZOTaxVA2SdkxVbr0BWkBVk5UVWRyZZC8fHPnf0G8V3rNav4O3rfefX4UvwJfxYeoGxswsU0nWfgsHbURDaijddIY6Kp8rOTcg5KBwyOzuptCi0U8U6NM6oD3zsBX54s7ygs9BCbDh+EN6cmaRevMmUahr12+/6k9S42WZybuGi6XrBLmlmmT95tsoxxlQ7tC2KGeZO0r4c3oePzY3uyGgybc2PzKafj6385Ubv6XbdWzc4yByy7Qb/K1g4zs+udm5yBcsjWcOTeYA2nYAGxfJy5oEDtJkNoSEHaFvhVJsLGLWV9JeZHZH1CO3CuKq6fuDtD9EuO+61P7u6PO310e/xOuzVXp8OxVmv0VWc9cr/rFfVNrPzhOSzXhm9FnMTryU02MAtcVvgmXDyTBaPprpjwrxYE+eb0OwLvklFU2iQa5LyF1Qt76dYBh8/ZfWbRE7LunfZ3mlpYDiXYJcXwrkI5+58OLdC8HZrZ0C1GMMU7zsjRrCfCwgFQoHQCgglKhAaIRQ7t4BQIHTnEcqlqGB7qNJionsIVezaAlQBVUCVT+SftSbhnUMVO7YAVUAVUOUCVR3L/xiq2K0FqAKqgCofqBqAagRVbNQCVAFVQJUPVBFTjaA6+3SAKqAKqAKq20LVQEw1hirOxgJUAVVAlQ9UUZUaQ5UAqoAqoAqo8oCqiZhqDFXslgJUAVVAlQ9UEVONoYr9U4AqoAqocoGqheV/DFXsqAJUAVVAlQtUbdSpxlDFjipAFVAFVPm0TyGKfKqW9c18mHfHXDbOHAcer8aZ64un0Dczuiq9b6b0VplZXGbadsrpormIuzW5i6ZK6/1NDtDlcCNIzx9Wc5ocmmaqwWD+9C5ezZjXvImwzswFq6Y+D8JysELhYadMOvGxH19DQo777bsQVd2+G0zb7nAYmVnoIf2rpryjgXc3XUF4sWcxLBy/FShPn7zgue/p5AVlYyJnG3ESxWirBR7THCN9cxgz2ilD/3vY6b7bqV6/nTL0Qoad7rmdaqbRJjXbKYM3CzvdczvVlfrt1Iadwk7L5n27/nnfgZ3CTsvmfVK7nSaRa9gp7HSlnRqhnWo126kKO4WdltmpWb+dEtgp7LTETs3QP9VrtlMNdgo7LbFTi9Rvp8hHwU5LearUP+8jHwU7LbVTvX47RT4Kdloa59drj/NryEfBTkvt1JZpp/SztGnz/sqztMeBV3KS9l9aS4/+9lEQ/qnh3xva4uR/BcvH8dpbVRtucbp2wdrkHq1tI60ELJZhUSXFE+ClQlHVEV2CmZaaKZuV2sJS9DBSGGmpkZryWEr9ADoKnmClpYH62q0UfimstMxKbaVmKyU2skkw09IpXzVqL8sj1LgSLBWWmrVUR6Cl1tzoJdUIYT7y2tYv61sXoPMLOr+g88sOdH6p0Odl26C+ikNeIoDijBcAFAAFQCsAFB1d4/NcAVAAFAAFQDcGKEH31rh7KwAKgAKgAOjmAMXpVxFAcU4LAAqA7jxAuXS/3hqpOPsqQipOaQFSgVQglcvuESSaIqTijBYgFUgFUrkgFamnCKkWkAqkAqlAKgek6khGRUi1gVQgFUgFUnkgFempCKkOkAqkAqlAKg+kIj0VF+1j2xOYCqaCqTyYaiA/FTMVO6HAVDAVTOXCVCSoYqYSMBVMBVPBVA5MNZGhipmK/VJgKpgKpnJhKlJUMVOxhQpMBVPBVC5MRY4qZir2UIGpYCqYyoOpFnJUMVOxiQpMBVPBVC5MRY4qZip2UYGpYCqYyoOpNnJUMVOxjQpMBVPBVC59plUTUI2gio1UgCqgCqhygSpRpEG1cPbZ4K1r9m5vfn3/c9357H94efsw7rUIw4mn3rAXP7rI7gbuZOJ3DzKnn7GeWFZ8KoxnmBUfnvfqT2+if7eN+Xc/E0sI/33ymnrZydv8m/UWt6GFFU28aEJ3j53x9fDS+PL08fjHm9e5dPxfrfkUNRk9BV1v3YOZT1ducO/Nx/s2vnw7/d1xz/sPDzfnHdPvX121nPkpi17v3ltrkSmLMygGl1wLvIE79Z/TY9GtcP4Os6eyPDRNN7Mmr+nZIWYffP5bS1suDmQkx5wuGrq1LdtZfpm5gWd3qjBwaLnuW+pl8ZF7k80/wFJzsxGXClzcY5ooGVXIcKJr7Sqka05Zq7mict+pCrWGqdDSM0Zstm1jKR3LNquK0siKo5WcKy9ahckbiZWhuQMy3MfJUGWVIWmcDNuGmRJe1qYd0taJsvhSHV6qNPW2YywHVmSJ1JQhUmsHRLqPcyWzSM2miTR70G/Lstt6SjyE21ypGm2ipkaW5MFGbyxBlwyHaNeuy32cPBVWXRpN0yVZN3mqNmk7QmRqmjXJNHrj1PsqW6l2EVRPne194fcCdzqazN43CozPrvffouve/Ho2fH7rTjym8DnVSNdHz7N6p8VZU3DIBVnv7u5It0vDRM+8NQ2Tqvb6I5Ppk+uLGNtM+hucZa/YOWPTdWmRSJolXrndYDR8mgZ+FMmmGl4wGk1XGt3SdpNBJgzWSJT1W462scee4dk9nWaPNrnVTNhj2h6dPHTl7d4oeDN0SzHELzNOFevQOMs6L6q2blUxDD/pTeKRRN/8XHou0bdLdyX+rraVxbaGlPZp1gk569WsnoCa49Qo+UlfM3MWzeq4OLncUsvScyPxclQUNT93EO6eyfH3L53O2eV1ePXo8MPh9/B/z78fdg7D/z3+8v3rl++Hnw6SD5ydJqb+dFDunAS3vU9OQB47l8rlbevkw+nTVb+1vp9f+WSQnwGUrueRg2WWduDdTWnCN0xDtcJxju4jaiQiTZN4FGVop9H9duhgbuBUElNsfvtUYY4MKa6qKdV/i3kireG8Pvh4Ml/D2+QdHGsHhydDN++cjKMf+sOt/OpPn54uPw1Hzuvp7a+nb+dHz1fdacnxvfCrpfnVTtYcacYo0a0+D9yJW1je3blT/hYozpOGBW5jgUTV24l3VIM3fTZRxx3Xuzu+OXnoXJ6cDq9ODufdc7K+c+iQJbPFMLzxGXc5ngKDaX90Pxq6g0+jWaFSePG3N52+zV1l92k6ytpRZf84b2fH8Vf8uoWHP/8jwytnfnQz4t/suZN+zsHn4/VSJWcUfV5qzWKi31Knd1tv1koyS0mthGK005EzlS10Vs1lPPNvg8KEe+ffegF/2K3fVQ/Y1QY722nbdsrgauMetV7Q1gvc2xpyq2EleFFfGwvp2QqHEYYqawRgaxjmlsnhUqWt6sQ2rNl/85VwK2BYHNg0nXaq8M2x82+THXdFAKFCno9u08W5HDbNyaZtVpu2a7Jpm5dJW/lx5dqwARuuZsPyKRrVMimL/1N1tlommsk5xYF1RTGc6L+mwliozMsECYWjlDVRsr9o/tgj28qlFaqsk+Y1D8m/U6uklTUPVddWpTtLsrqZf+wolnjmPvqDaJgLb/DsRbtcDrKpkiTomNKc5mjHsc9MTc3kt+mQ42P7TLxAm665yIfIOBgGRYEFH5uDAIVB3/98Zb6cnFn96+nV0c2Q/Ly6aCW13Cv0tpTR6fIqQhKlLotVdFmod1/W/BE6y3kra6draogmyujokS+pK8Bm2YaabHYrD1gpsryLXMCKMJZGb7ooK4wr2sykOrRNMzNK5THdzKQ5sXkzM5y2qeuqbSq6aaiqIcjq8uPys7pP1uTwW/+T/hy8HprW/f2teaG05mxrdMVvlUr8namzqa6k545+o/iO1foVvH297/w6fAm+tNRkG1taSdQnzyokSVU1xFIzQmjZeS+VuRxYU7PSbVmhdm0muW5cWENyUZCWs13JL5tqd6FOv8oKdX/Ux+otSVKfpuXUV31/aUF9hrO9+nhPe7uwS7TKthZMe2XCa9gu78K0Z1mVpz0rLzyJ057Jed8oNeBq2AWV7m3Mv8r0Wl101FWbRdEcddEmLTSQr3J2dL29yHSF/3WY1FCe6woHlpvtSirMYfmNsHybOVxRl+XbpiDLt8WF/OnL1KTC6L25atJdrqq+YXXtrIs7lO5lthsWoNC1/O5lRVPy/lX1LcsFXQnbo2xLcdUcTFiCguVJX6jyEqPa3C4lW2NUPd28IrgmbfJBeHxn4wRbTT5Ww8IEupFb2zs8557CakbY3JO8k9C5x0ysAXNPIxZLrHteWDXHf7FERC2WJBd2myjsFuV12azBLtYWTNyt2BIV7LLEBbvok/QuNLTmk96s6oftltfF2r4s2WvVGK/LzC35raQF0/Y+l5XfL1F7TjTZZdVo2b3z7n/byadpi5aCfCx+8pG2ZLGkLFmKUoPjxslxYw2XsU4+/B03W5TjJm5PHhVUyYTR6BkE4TIBM0/T+s4KdNwKa3pxiZrterQxen3JgUi7oFkstjiGuBu22DJI/mgFnWeIe+sDFLbrdHM5nHrDid9ze+H1W/e3G/7PX1OvO/S7o//N/rJlB5xPl7Mr2fY3fnRe3GNoTu6UsQ3OSvPI8oFTGxyHnNo2tXtu6GKpmlLU92KrL9rjLGcBJW+5yc66etrRZQzXHUwL7ZouBBrrtt09YaySjdWu8XBE+sIa7ZuELaxJ0dOgLqxZD4vhv7BWRC2sxdWhOIf/jV6//ro1fuie6f37qJ08f2hZ++Ok75azTUkK0rXSsP1ehQWymUQgOZxctnUlI/e0OHpFCZsEWPtDWHVNAqaoSviCnYueBLQdmgTe6al5200CZH8mgYKHJC4/x/+MrdPhNDQN9zE6k2gULXbD5aty9+QF/xVWv53rA2GrX3EHBGD1K2T1a9pNW/2acHxE7cJgbV5cV5/XlimqqtUUV9VKdXxUfRfOC97HyiRWzycRS3M8Hztn0gZb61iW5a+0/LDJOT9MF9+7XXbsQVEH9YnS+n3SH73TsC24JNkTnChA15y2qqaa6VUUsabmVkKaY7dF6Zjkz3E1OFcYrtDxLu1lfKcx5G312LAAgqbnLFnTq3cNy8cilO0FyN0RTTos7YSG0DeMq/ZYA9h1zYVEU/nMhVZOiYSDElmnQo1z90x6VMQqiBZREU5REdbjb+o60alliCq2NyQfgJM0yYcV87dik9GKVdYFEn8zFtVixZBc2qImsaF351Ptum+0WP6Xh/dYK7ykterKHiDSinruMwatGSJ8BYkIi/AZUtyh99VVtdpCpmETEGVZQp+AamutaojqNmGI6zZBx1yykNrBCejd1NVsOwGxJlmltevKraENvhPQ1r0jmCcgW8IElBDgnUxAjZpIWHtvqayhZe4TiS6qPlMXV59JN+PitAEz5nREIWuVcdKwU74Za6LiSpq4uNIKfwiJwqb6Q4TRH7KbVm+TsHHBZlVvh5a+6kDa6q6R3rykob0LScN3Xr22pZ4c1mV2bXpSBOmpMPsIW2poUpYaaA0sbCcYa0G0WlufX11URXRh1lkhuI1VYjor3klsrZi9CwXX+xkSY52ykpV/c6csYS6gtJNUdM4nqax45Nj831QxMsenG1Y8ZpBcgtSwuMant27OunvNttZZSFbt2MNJEWtj9nAaCeTfd7utdd4FzHV3zFXXpZkr4wobR5AIW2EzlyXWdgaJJqoqRJNdFeIgC9JUr5tSHEXXS8O87nAJ3M4XhhDHalu2iMCtxIa3jDMDunAJmxmY6wVr68WoierFWDB04TODuUMzw34FR5lnhqYVrEudGaQdnaNtt7G9Ga251pkaVsq7s1LW5PVRZ/SH0JxLmD/Eug1Vra0tKRFV9koktyVVk53mjfaH9rO+idkfatr+CUsr+kO2I8YfKghGmD9EOOeLv15arR9f3t7uXfXh3970nw8fb4aLOpyMHM1B+ISObsN/3Ef/UKNnnfWkZq8I33HxojWzkxCnZm9dlUKRj6oaRV9lcbQGTXAb+CoFK3ru6DeK71itX8Hb1/vOr8OX4EuLMHR9y9oDD29lwflVDm7Oqs7I8bF9thbvm4RGG7o3lae7tO7ky1JvicjKK9haThHxEZnO9s1t7KQLWnpg01g5q6yYCiqwmqoyDSrjrjLhakmafpTKRZPVHaQgl7g7iJKy6qrdTQt6MeIw7uqRBQtGh2B2UDCUNsF0wZC6BBNVhjspwWi89BINXN/8YjJsPWq0XPbVI0vikuWSkRXAWhx7PLdsEk4xKcEopKJkiKJZhYHXzV2iJcOw9QGS2VwylUpVhMuMsMpMVr/CvMw0Tp5cQWZlA4uWmcSg8aaaqmKqO9NAV7y3x5p7MRoWdM47hXY4waVDDhUDzgXlheNq+upxBQsv2YaF+W0f5jfmUIWsU4oKbqThiJnfooGTtmCypLXrq619DE6w7lon0jzAQjDPFhSbMGqNfSet36GWHVKLyhyXkNWYtCgXXZRc9FrlYpfLZdJ34zLH7lMweDsK3O5D9IzKMvWbLKMYKm1yAjpVrEPjjGqbYy/ww9viBdHf5g/vE6v3g9Cq/dEw+mu9yZQqvmYVC2ymMvbSALLojp4YoUPZnsqpiJHNDlUF3N49brOuyYm0dUAe26aoDIxZawZG1RkWBeD2++c2pfpcLrd1hm1LMMR3b4g25YxyyYbIkGGDIb5/Q6R0rpBsiFhSwRBDQ1RqN0SGZCgM8d0bolX72t5gWNvDEN+/Ida+WDEYzmSCIb57QzSTC/UZIoEhwhBbZu2LFYNh5wMM8f0bYu2LFYOhMR4M8d0bIq1PrmRDRGYFhhgaYv2LFWRWYIikpdeeWTGQWYEh0nuCSzZEBLRhiNGpdMIMkdYbsuP1wo/kBv5oNlyqFeTswpadIOm27mipu4JOkIxGKLG9Esm33qMl/CQe8fE56ls6WWmrn/kYK7UjHLqWNt1WSc5W6zzfg94YLHnzRrd7rNL+eme28G5mfenaYOrrKDug1s10pDEbdtV869NFL9SNq4YLulukQHk3hVT1/DtxPvd2hWoZ8lgNVa0K1VJeRxRK175Pn54uPw1Hzuvp7a+nb+dHz1fdaathB4EqhVN5q547qOT7ZhJLUCfX/N+cnDkhWLMMKb/6NctNf++qIfOWmm3YTJu3f7VqtydVVXNtndXEqEVrVuV8cvYKze7EsWHQrADN6g3TbM7RXIRBNneOlZxmDUmSTRa1giXLsA2gfsliQUuT7Dohlp56sNjK3BTJktzkqCZHxGx+yIHutNO9q+ysrrY+G3DV7J47W4HI8ZN34QCSKjPl/giRtVO2JCFqucNHiCghGrKEaPAVouW0jkf/vHZeyMlAezXcsX7+ucVQj9VQGa6fR3ddhpT221QZOg1ryKjl/M7kOKOtj/yxJamOc2SXKrpdOIx0J3qw1CU61r5ysnzQnOiSsAnvqa8wLr9GLFSdMJTG1a6TffQRmXXSsMPciZnTSfXZKdn+nYxkru+sL2q2UjmfTnfx+fxocvGl9cU8Vu68q4n1+eW0RSseyB1ORyKbyB5PF34MpedH1TKTxcuD5Tl1OLuuroIVYuQT59Sz6xabRXifXUe1seLe4S5Xezg7PHFOjLVTwKpSp/21EztnJ45VNJNFsVPaTFQeZcpUO6GlV2coiR5fxl7MP0+j5AetSTyTH4YvUMn4dUag+c8T/nw+ONYOjg4fvWBxSHl/FLgRx6bhAxt4kxS1Zu+2Alxb1kNnTbWCT7LK9u8DtxexOfnZ/NTnZhm4MHNebMNcmLNKMWfaiZ2mKGsWn3hcVMdv2oOz4d0zG+JShusWp53tjh9FRp22Ym198CVtbMdeOzS/9RjVXDcLFs7pwnsxphpryNeodVRTbNTMV285CmkbFaPj0b0uH02wIao0cOaWJNfJnL1chSh/9aI5/vAkntTjGX62ZBn9r4YlCoNL2qyZWaLraeUrblWF4ntSi+rFLVE2PipkM3s4Ojy2TzTqklXTdeMESxSGpazFupIVt0RRaWFLiWuUGe/ia/OATM9dH4IRuJjJGfX2i5nFgPu9mMmnx1qmU/diRt2sJmtj93CZmoJ7yNM9NEwzZ0qW1baN7dcvjrHZwKKdRvElR1htS19tW7bZrnzMI208ozieYMOk7s5kWc3Qlyi53wyNabpwFlLrH4Zf/Z/wNdCt27V7q33eXuMm9DrXQIvzV2pbApGVhtrznys6too78O+HmV/qetHO+aL3y82N5jbQXxd+L3Bnyc6lAz5k8dLTvnn4zJcvCc0xMqiodUmwfN0sqRoqMny20V2jv/NKp37t5ebcT6Y7t+sfMvPkd/3DUI134t2Hc8KIYr21fliGxe/icgw05Pd2aElczO9R2l1Sl8TiQoa0Ss8aJszZm+3pRLvrhH3/0wV8nQ3rTXbkE76Dh/T+xffefDUJHpz0pIYbdOeDNq9wVVyKw8zn9ih91eSmOKxiag9lqnXHyQplqqFRtImaqsbXi2Yjt2rVoqXGULaKZS3LsjZfvaXa5eYtlYo2LX/BMfGLukBRdYH5ylXTaFtmcftfhRrBDUcWnGGzi4kLvvM2arc4zNsh0xo2b9t7sN0EFVqC5u18OFoz2o6Rtm6j7nl7s+0nKNhqzLydtyylrae4qTqk8ry94cii5+3VpbT7WnDwNTR6b1bFM3Q3z4bsfADz/QdkS7Mhu/6pCya86x9ov3JSO/8h3z9C3ltOB4HKXVjw5N3S8I41LFC5Ogy/E+U48Hnh877PCQs+7659oPfjDsLn3bUPsxc+L+e/Y4+rp/bF/84Hb+1cwoEx3yCsGt4p1gmgeopqIzVmYTWnbdmpRL1ZexI22Y37npOwiEmIYmK2EMXJW3fdSCwWpnBNwaJ0SlAKNmdXquK0FbsY6tq8Z4az2cCCE7BOsQAGhVNNm7JVK7QRbT3VJE/ZtMqSdzZlYxkjZ8oOmVhpzhaWRXAEt0FF2ZScOZvoWttM9dLVKlY7F+bssoFFz9kN2XTenHjhX+fh/IDE0e5/nj1MHC1Md9c/yPvJpSBhtGsfhoqO95YwQkByJ1Y32bW7zhBulxuRRMk9vMcDeI/wHhv1Qd6PYwXvcdc+DLxHxMab6T1GrUDKMj+iYuP64eX3h+7x+Phy8sd5ug4uvl19phzjiWwhzUJkZgutXC+ORfowbSW0wPuitzh3M6FVPUhMD4bwfnSHlD7czAwFLXeQli2D0kBfLh9p/USQOty51GHLIErmvPeqB5DkU4dlA/NLHVLNc3XZxk7sj2vOkuEvd75oCFd7JJyO1FRM4Tb7I5L6UTf7Iy31o3b4tbOLCyw53tEkSjsEnjaJ6qImUYHNNEPZhn+TEkr0uAvnb5ft1il0D6ac9u7I9P1oiRX5vh+B77eZ7+eYJGtIplXx6Gzi2GVDCfbvaJVhMMEdNEG78oKjYIL5oQSbIO0Qzm2XGM10d/F58Hn28vNEa9/4F5X+hoc2xd9k8mkHyzNLo7c8WGYT38vdSiIEy5s2vxmZHGqzb0JjbuatMNMjzbvrvEyPMJteA29CY25mV5jpac2767xMT2M2vfd4E1Z/Hs6R1h2/G3WUsCzOHy+Py6060jx8a394f7BXh3YVwsU666Fdqioq8JYMzBj26A7cycTvbmQtp4p1aJwdrC4/yVfDk+Nj+6z0kW8d79i2zqQpERDLcdpJafwicpEvT2EOgtBGM5zcaJXjIKPb3+FDCEcauLfeYDbY5XDqDSd+z+1F7zCYurP36oVPd/aCi8vZleGo512/jec3yo/ynY/hU3an3udR5CeQ2KkYDab+OG3Jif0P3rpm7/bm1/c/153P/oeXtw/jXiv96OZ64VSP5ak9w7NognBMS3Mjw58M3fH1aHYbm0hCeZVYqp5no0ppybUoukrLqEKjhvDbuSGuNMrTvMsZ+aF3T17wX8E8O9fizJPAPJtpnkbbStWW2k6txvo5stCJ1ws/tRv4o/SK4XUaFAz29EKcwWow2EYYLCEFnurtVDF0aLKyLLbgiB72Xn6Of5lPd7dfXnWt8/H8308fWsSiOJ6hh9WZfztPuIX3MzbY+YONTCDlf0Y3eRRM+6P70dAdfBqNxvP7/NubTt/m6xL3KSR6xtJiKR253Yf7eKjEtHrenfsUr6YKJnccf8192rNwmhhE9/nCGzx7U7/rZhdCarIwKg5czCjW5AxHoYW3m/ktjL/5GX3TNpJvT17TPzx5W3zXO/OjBx9/13Mn/dxCoLq1z1zW2eu+jS/fTn933PP+w8PNecf0+1dXi+aHM290zjbP06a90VtvEvwdVRDenJKLxWFepR77tq44KbT5T46RLPGcC0OpplUcinpiQImHXyE3uUKfem36rGqc0HW9+jRZ9WlJ0yfJTIL5k1jVcI5MVxg7vMSr1i1eC+KFeDcSr8YqXqch4s1rl612h0W8hmSxahArxLqRWA1WsZoNEauZVatGuInVNOudaQ2IF+LdSLyEVbx2M8RrivKSo4Eph3JIk64D6UK6G0lXZ5RukkCtWbqa0VbSP63sIptOdlyN3qmNv3LpWbLNto5XKWJgOyxi3VY079Wf3ixFHX73M5F0+O+lvqNvEnkXExqN2gOS1gf1wShFeayN5DakpELVLSWbLMn7mHbbTh08kZjbpsUWqmFsGORdodDQst231MvG0Qsm6z5gfgdg/MZKYe5dCnX2FrzKPG7d31Hh4l9Trzv0u1FnqGyK8pPAkg8ldV+QomxQTp0oZjtp6lBDWpKezyYNmVrW7gxM5hY1PbMs5hnWuaWqE9rYOYn6Oqc4JzmH/41ev/66NX7onun9+6idPH9YNHttypxECtWjqtPWK57LUKwP0PMVg/z2OtKF1RSfjUlYWadNXSusqjLaIWePVVirS4QarCti55TALqq8O6flpyle/puq595pvsCs6K8xSpbWAmlHJLt+nbUHkl0nxVLJskYvZEnWzoYfWqqhtJMigo1Vq2m50UIiFEbjJVxi5/MV87WvWOVudizXDnmxUO565TYssBJqrZ3ENBZTl1ldu7pitw2rON6a4Ixov3azPjKNmiT33q/dSmqkYVJTs9MacdoqoaQGNp8vzcJ8GQq4GDsUPneqfH3e597xz+eHh38+fvzgdt+OXv+Z/Jwmns86NS8Sgk/B4O0ocLsPkZmUhQ5ZNV6t0d1iz2UREWMvOthj6gWdxR7cWGV+EKrIH0VdRV+8SZw7nL3tTOFND1xuJvoNdu2qVtbcKS0eOQUo2SySoY08LHKvLFKldG+UapIMMXKY5Ps2yfzU7NRskgzRZZjkXpkkoTTbkGqSDNFTmOR+maTtZEIVxdy3KAOlFkCqSeyCZpHUasfo1lWpdqwQ6Nu80jFj9xtXOqYb1FDjNTvatSYd7qCWKs6jaaUljUTSpj3V1nIhc9PU2+lqw1z9MXMgw7b04sCmUdAj/8jhCvnZkN/ey491Jw+RtJOnKD9LFyS/aOA65Vcs/4f89k1+rC0lCGsVC3f5OUquiJ+X/Bwl1DVb6J6b5pI1GTS3x5ojrJqT1MalqDlblMdpxx6nZM2p0Nzea05l3bmm1TbRaXZujzgv0UUD1+hn6sW438bbTCHJdyhJ1nZJWm3zoKaIkqRSryQ5dFyBJN+hJFmDoUmBrXxJknwnFV6SJPUGQ3UO7QYrShLyqo6mykWiwqVM2Z5El3JdgVWVVK3IzGs3HKmt6Rv3eeCmXbuYyGjydLrSZhWtxGpBivkLorvyNakGkCVpSncJ6uuSIGMNsVo+qRKiaPk9Drr8uJFdzI/spKqh6WY41xrreteQ1GFUdZzN5tHK+q17gnaKaRdIGVKuLmXWqgVDVtFQXsply9nqU3HN62SnmM2BlCHl6lJmTQwZstbJBSmXBIurS7nmKHTSCBZShpS5hLyYZ+XaoteaziV6TZFyvbWEzm4llCDlhktZYz2Nw5CVGy7OyuurKraQcr3lGsnnhJQhZS5SJqxSllV5VZCyTgRJuWRg4VLmcDYHpAwpLxxsZimTuhxsnU95CEXKNYe9iltVIWVIufqszLrxx2DtqMd9Vjbi/TkpxbEdssGg5XhkfWWaWriWORxOCS1DywstsxaGGLIKQ4paXh+e2kLKNce93knlF6TcDCkT1qpNva4akZYhKu5VMrBwKaPcC1LmKWWbVcqSjrksStkUFfcqGViwlBcnXEDKkDIXKbNui9JrK/cqaeW0hZTl79gnyV8P/UK/PPTLWnit19djShG0ccJSapAv6rogX57TL7N+ZdV1FabfklZuW+hX/sYnoqCYC/rlqV/WusxkD3wN+hUV1JoNLFm/qOCCfnnml1jlW1vrLJsIcp9tUoN8UbUF+fKcfll3OCWN2uRPv7S2kFuIto6QFeqzIFqeomWedGurz6L1T96iw4f8bsxER8qXLtrj+IuzaOe3sybF9txJf/HAwr/qzI+MRU7jHp21QMuUtAAmauEQYUqciVnMRCVtykmr6bHXeOeiVW4gGwyVy1A5a0m1KSlMTVH5NlN2mcrXn9MgXOXIGUPlMlROWFUuKZlcVPlWq+kSlZecDCFc5UgtQ+UyVM66/DYlVXxRVE4JTXNT+fp4unCVI4EFlctQOWtk3JRUol1UOS1/zEvl0dh1qhx5LqhchspZy09MSXuqKCoXGH0rOb5UuMqRGIPKZaictUjUkrQJmqJySi02N5WvLyAXrnK0NIDKZaicdSeWJSktXlQ5bcMUL5WbNUff0O0AKpehctat05akijWKyjltnS4TPFnbzky44FEgA8HLEDxr2xNLUol5UfC82p6UCN5Yfwi0aMGbqJWB4CUI3mCtiEtOeqxB8Jy2dJYJfv2JAMIFj7IZCF6G4FmL46zaiuNKuoJyE7xitNWU4PNtTYUrHiU0ULwMxbMWylm1FcqV9PTmpfiSnuTCBY92DhC8DMGz1sxZtdXM8Troo0zw9Ubtkl1EdQge4q0u3iq0rFXwrOVzlrTyOTN/3p6o3S5azXE61M7tDRZqlThr7ZxVW+1cycmX3ARfc5wOZXQQvAzBs5bR2bWV0fE6DrtM8Eq9gkdFHQQvQ/CsFXV2bRV1RE6YjtQbprOReofgZQietbjOrqu4zjbaWjoPJ0bvdq5dheQzShKcQu6Qu1C5s5bW2XWV1qlEit6jt6lR8JqK4vm9EXxW4xn5iz/shDUqr6qyYnaatk1/OGb9a/noP62pnXCZo2QeMpchc9bIvKrKyr6VyXx9g7gtZJ4/KFyu4gkW7lC8DMWzhuZVVVaBTYniS5rFVVd8DR3eNYIFO2QuQ+asAXlVlVU4WyZzTqevFGUu//QVjRDIHDKXIHPWMLyqytoRUyLzknZx1WVewxlpGqmxKB6SlVsjW6vMWcPvarIPTILM8/rTqxbJFqVcQ8QtOd8KM/YeyL9GKVuse9ZVVVYqrWzG5nSqeFHm8k8V1whK3iFzGTJn3amuqrIKZEpkXtIVrrrMaa3shMu8xkJ3SHZ/HPOkdRyDzGUVvpbJnOhti1iGbRLFtJ0kHcBB5nWE2VDevj9oqFPmrJvSVVXWhpYSmZd0gKsuc6OOMBuK3iBzGTJnLnpTGlL0VtL3bQuZr98PK1zxjat/U6B5oV7/Vy/wQ7PxgoMGePXMVXFKQ6riytrBbQGCfFmc3EZzizRDc0gADrzLuZ+5Lk5pSF1cSUO46pIvaWgnXPEokYPiZSieuUROaUiJXElHuC0Uv76jnXDFo1oOipeheOZqOaUh1XIlDeKqKz4a2Extl7VNyZJHO1lIXobkmSvnFHmVc9u0iNtC8nrNkkeFHSQvQfI2c4Wd0pAKu5ImcVtIXqlZ8o2rtlMJRC9M9A0L4yfNkRhA0JAavJLmcdVBEDe/qxMEaDy7PxioU/LsGfyG1OMRNSd5wk3zas2aR3EeNC9D8+yZu4YU56n5aZ6b5tW653lU6kHzMjTPmrtzGlKop+ameYXb9hq17mm+caV6kPy7lDxr8s5pSE2eKUrxNc/xOiryIHgZgmdN3TkNKcgrTPFVW1AX5/i84iUX4eooyYPkJUjeYU3dOc2oyNPWN4OvLPhwXC1djqfJnuJrLMiDdrlvny9LejYtb0dYKSCvSi+rz4RTWwvdzgld9ryOKrz9YUOdimbdP+80owiv7JSXynqPT6mRIviH6cnPw86flmrd9r48vr11Pn19ac0fw7M7eJrfuYL+F2J/CgZvR0EomuiBHb30/anXGbvxY34J3HFWzVkcFOR0RswT086qximKZnZPihI5VaxD44xqqONk3or+Nn94n6jDD0Lr90fD6K/1JrHGh+74ejS7tTMNFDXiDgajl1iuk/mV9aLsDkJJz79XNhdpeK97MRmUjSX37AVT73WtRBIbVJMa2EVVWGKUL/MbGb1qfqnv+ff9+ftrympZZSxzUzPUYYYww+WRF3WZoQEzhBkuj0yVYIZnE3Xccb2745uTh87lyenw6uSwVSyTWdqPIncRvdoPruKu5w8szPnBko8w1FhTxmZdRxQTXk0c1h9hSNafoMTPBaVae7FAZHtrl7iUXK2Qhlk7a7bUJHVZu+G0kw2ZvC08HnopJCLVwpnqIYB4EUbPmjE06zqlVgvZq8V9Nw1DtYhetcB/vf1H7yKsRR/V5lWmmoB3QvoyO5d8NgRzbK0ZFe8U49wgnKYWxqoP9ElL370gfcOMnjlFJMu9WW/0xFTaoX0uwM+t7XI08Lo1g2gJMCWKwX0REmDd3eg0Y5dzybKz8hxQtmrmpwD/85X5cnJm9a+nV0c3Q/Lz6qKVxLJXCGBp66fLq42cEuqybepNpZg29XXcLXtFIC/8NhiNpmnLCdxx/2rU86JX/B8=</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-29",
    content: "<object label=\"\" units=\"h\" data=\"duration\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "h",
    "data-data": "duration",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 80.04,
    width: 140,
    height: 1439.96,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-73",
    content: "<object placeholder=\"value\" value=\"1\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"1\"/>",
    "data-placeholder": "value",
    "data-value": 1,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 209.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 229.55
  }, "1 h")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-74",
    content: "<object placeholder=\"value\" value=\"2\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"2\"/>",
    "data-placeholder": "value",
    "data-value": 2,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 249.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 269.55
  }, "2 h")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-75",
    content: "<object placeholder=\"value\" value=\"1\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"1\"/>",
    "data-placeholder": "value",
    "data-value": 1,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 690,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 709.8
  }, "1 h")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-76",
    content: "<object placeholder=\"value\" value=\"3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"3\"/>",
    "data-placeholder": "value",
    "data-value": 3,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 669.8
  }, "3 h")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-77",
    content: "<object placeholder=\"value\" value=\"2\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"2\"/>",
    "data-placeholder": "value",
    "data-value": 2,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 629.8
  }, "2 h")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-79",
    content: "<object placeholder=\"value\" value=\"3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"3\"/>",
    "data-placeholder": "value",
    "data-value": 3,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 549.8
  }, "3 h")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-80",
    content: "<object placeholder=\"value\" value=\"2\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"2\"/>",
    "data-placeholder": "value",
    "data-value": 2,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 509.8
  }, "2 h")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-81",
    content: "<object placeholder=\"value\" value=\"3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"3\"/>",
    "data-placeholder": "value",
    "data-value": 3,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 289.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 309.55
  }, "3 h")))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-82",
    content: "<object placeholder=\"value\" value=\"1\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"1\"/>",
    "data-placeholder": "value",
    "data-value": 1,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 450,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 469.8
  }, "1 h")))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-83",
    content: "<object placeholder=\"value\" value=\"3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"3\"/>",
    "data-placeholder": "value",
    "data-value": 3,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 429.8
  }, "3 h")))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-84",
    content: "<object placeholder=\"value\" value=\"2\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"2\"/>",
    "data-placeholder": "value",
    "data-value": 2,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 389.8
  }, "2 h")))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-85",
    content: "<object placeholder=\"value\" value=\"1\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"1\"/>",
    "data-placeholder": "value",
    "data-value": 1,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 329.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 349.55
  }, "1 h")))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-78",
    content: "<object placeholder=\"value\" value=\"1\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"1\"/>",
    "data-placeholder": "value",
    "data-value": 1,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 589.8
  }, "1 h")))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-86",
    content: "<object placeholder=\"value\" value=\"1\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"1\"/>",
    "data-placeholder": "value",
    "data-value": 1,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 810,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 829.8
  }, "1 h")))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-87",
    content: "<object placeholder=\"value\" value=\"2\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"2\"/>",
    "data-placeholder": "value",
    "data-value": 2,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 869.8
  }, "2 h")))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-88",
    content: "<object placeholder=\"value\" value=\"3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"3\"/>",
    "data-placeholder": "value",
    "data-value": 3,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 909.8
  }, "3 h")))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-89",
    content: "<object placeholder=\"value\" value=\"2\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"2\"/>",
    "data-placeholder": "value",
    "data-value": 2,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 749.8
  }, "2 h")))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-90",
    content: "<object placeholder=\"value\" value=\"3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"3\"/>",
    "data-placeholder": "value",
    "data-value": 3,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 789.8
  }, "3 h")))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-91",
    content: "<object placeholder=\"value\" value=\"4\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"4\"/>",
    "data-placeholder": "value",
    "data-value": 4,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 940,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#ffb366",
    stroke: "#e07100",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 959.8
  }, "4 h")))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-92",
    content: "<object placeholder=\"value\" value=\"5\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"5\"/>",
    "data-placeholder": "value",
    "data-value": 5,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 1090,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#ffb366",
    stroke: "#e07100",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 1109.8
  }, "5 h")))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-93",
    content: "<object placeholder=\"value\" value=\"4\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"4\"/>",
    "data-placeholder": "value",
    "data-value": 4,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 1140,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#ffb366",
    stroke: "#e07100",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 1159.8
  }, "4 h")))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-94",
    content: "<object placeholder=\"value\" value=\"5\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"5\"/>",
    "data-placeholder": "value",
    "data-value": 5,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 1190,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#ffb366",
    stroke: "#e07100",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 1209.8
  }, "5 h")))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-96",
    content: "<object placeholder=\"value\" value=\"4\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"4\"/>",
    "data-placeholder": "value",
    "data-value": 4,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 1040,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#ffb366",
    stroke: "#e07100",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 1059.8
  }, "4 h")))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-95",
    content: "<object placeholder=\"value\" value=\"5\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"5\"/>",
    "data-placeholder": "value",
    "data-value": 5,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 990,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#ffb366",
    stroke: "#e07100",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 1009.8
  }, "5 h")))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-97",
    content: "<object placeholder=\"value\" value=\"5\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"5\"/>",
    "data-placeholder": "value",
    "data-value": 5,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 1320,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#ffb366",
    stroke: "#e07100",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 1339.8
  }, "5 h")))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-98",
    content: "<object placeholder=\"value\" value=\"1\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"1\"/>",
    "data-placeholder": "value",
    "data-value": 1,
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 1240,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 1259.8
  }, "1 h")))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-99",
    content: "<object placeholder=\"value\" value=\"2-3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"2-3\"/>",
    "data-placeholder": "value",
    "data-value": "2-3",
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": "2-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 678.5,
    y: 1299.8
  }, "2-3 h")))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-100",
    content: "<object placeholder=\"value\" value=\"2-3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"2-3\"/>",
    "data-placeholder": "value",
    "data-value": "2-3",
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": "2-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 1379.8
  }, "2-3 h")))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "cell-QpIyEjSaGhkkXGS6ihMM-101",
    content: "<object placeholder=\"value\" value=\"&gt;3\" placeholders=\"1\" nodeType=\"durationNode\" tooltip=\"\" label=\"&gt;3\"/>",
    "data-placeholder": "value",
    "data-value": ">3",
    "data-placeholders": 1,
    "data-node-type": "durationNode",
    "data-tooltip": "",
    "data-label": ">3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 1410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bdd0fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 679.5,
    y: 1429.8
  }, "&gt;3 h")))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "cell-5sFhVjhy-AVEURoqCE_i-0",
    content: "<object label=\"\" units=\"g\" data=\"preTraining\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g",
    "data-data": "preTraining",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 1350.04,
    width: 160,
    height: 170,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "cell-5sFhVjhy-AVEURoqCE_i-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 1455.1,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 1455.1 L 773 1455.1 L 773 1495.1 L 793 1495.1",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-20",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 1379.8
  }, "0 g")))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-21",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1410.04,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1410.04,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 1429.84
  }, "0 g")))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-22",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1460.1,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1460.1,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 1479.9
  }, "0 g")))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-287"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 1405.04,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 1405.04 L 773 1405.04 L 773 1445.04 L 793 1445.04",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-286"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 1355,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 1355 L 773 1355 L 773 1395 L 793 1395",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "cell-5sFhVjhy-AVEURoqCE_i-16",
    content: "<object label=\"\" units=\"g\" data=\"dailyTotalRest\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g",
    "data-data": "dailyTotalRest",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1420,
    y: 1450.04,
    width: 140,
    height: 70,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-91",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1460.02,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1460.02,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 1479.82
  }, "0 g")))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "cell-5sFhVjhy-AVEURoqCE_i-5",
    content: "<object label=\"\" units=\"g\" data=\"postTraining\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g",
    "data-data": "postTraining",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 1350.04,
    width: 160,
    height: 170,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-38",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 1409.92,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 1409.92,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1179.5,
    y: 1429.72
  }, "0 g")))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-39",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 1460.02,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 1460.02,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1179.5,
    y: 1479.82
  }, "0 g")))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-37",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1179.5,
    y: 1379.8
  }, "0 g")))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "cell-5sFhVjhy-AVEURoqCE_i-14",
    content: "<object label=\"\" units=\"g\" data=\"dailyTotal\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g",
    "data-data": "dailyTotal",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1270,
    y: 1450,
    width: 140,
    height: 70,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-63",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1460.02,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1460.02,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1338.5,
    y: 1479.82
  }, "0 g")))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-289",
    content: "<object label=\"\" units=\"g/kg/d\" data=\"dailyTotalRest\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g/kg/d",
    "data-data": "dailyTotalRest",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1420,
    y: 80,
    width: 140,
    height: 1370,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-194"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1489.71 160.75 L 1489.71 184.38",
    fill: "none",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1489.71 189.63 L 1486.21 182.63 L 1489.71 184.38 L 1493.21 182.63 Z",
    fill: "#e07a5f",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-213"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 110.75,
    width: 120,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 136,
      marginLeft: 1431
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "Totales diarios (")), _b2 || (_b2 = /*#__PURE__*/React.createElement("b", null, "resto de d\xEDas")), _b3 || (_b3 = /*#__PURE__*/React.createElement("b", null, ")")))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 1490,
    y: 139,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Totales diarios (res..."))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-92",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 1410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 1410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1491,
    y: 1429.8
  }, "0 g/kg/d")))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-93",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1491,
    y: 1379.8
  }, "0 g/kg/d")))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-94",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 1299.8
  }, "0 g/kg/d")))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-95",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1240,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1240,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 1259.8
  }, "0 g/kg/d")))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-96",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 1190,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 1190,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1491,
    y: 1209.8
  }, "0 g/kg/d")))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-97",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 1139.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 1139.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1491,
    y: 1159.55
  }, "0 g/kg/d")))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-98",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1090,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1090,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 1109.8
  }, "0 g/kg/d")))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-99",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1040,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1040,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 1059.8
  }, "0 g/kg/d")))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-100",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 990,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 990,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 1009.8
  }, "0 g/kg/d")))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-101",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 940,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 940,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 959.8
  }, "0 g/kg/d")))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-102",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1491,
    y: 909.8
  }, "0 g/kg/d")))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-103",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1491,
    y: 869.8
  }, "0 g/kg/d")))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-104",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 810,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1431.5,
    y: 810,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1491,
    y: 829.8
  }, "0 g/kg/d")))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-105",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 789.8
  }, "0 g/kg/d")))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-106",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 749.8
  }, "0 g/kg/d")))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-107",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 690,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 690,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 709.8
  }, "0 g/kg/d")))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-108",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 669.8
  }, "0 g/kg/d")))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-109",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 629.8
  }, "0 g/kg/d")))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-110",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 589.8
  }, "0 g/kg/d")))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-111",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 549.8
  }, "0 g/kg/d")))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-112",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 509.8
  }, "0 g/kg/d")))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-113",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 450,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 450,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 469.8
  }, "0 g/kg/d")))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-114",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 429.8
  }, "0 g/kg/d")))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-115",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 389.8
  }, "0 g/kg/d")))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-116",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 330,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 330,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 349.8
  }, "0 g/kg/d")))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-117",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 290,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 290,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 309.8
  }, "0 g/kg/d")))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-118",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 250,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 250,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 269.8
  }, "0 g/kg/d")))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-119",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 210,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 210,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 229.8
  }, "0 g/kg/d")))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "cell-iNM6wDF7hTtMBXn2YMH--3",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1320,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1320,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1489.5,
    y: 1339.8
  }, "0 g/kg/d")))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-207",
    content: "<object label=\"\" units=\"g/kg\" data=\"dailyTotal\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g/kg",
    "data-data": "dailyTotal",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1270,
    y: 80,
    width: 140,
    height: 1370,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-61",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1360,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 1379.8
  }, "0 g/kg")))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-62",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 1429.8
  }, "0 g/kg")))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-64",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 210,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 210,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 229.8
  }, "0 g/kg")))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-65",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 250,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 250,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 269.8
  }, "0 g/kg")))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-66",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 290,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 290,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 309.8
  }, "0 g/kg")))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-67",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 330,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 330,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 349.8
  }, "0 g/kg")))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-68",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 389.8
  }, "0 g/kg")))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-69",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 429.8
  }, "0 g/kg")))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-70",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 450,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 450,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 469.8
  }, "0 g/kg")))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-71",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 509.8
  }, "0 g/kg")))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-72",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 549.8
  }, "0 g/kg")))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-73",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 589.8
  }, "0 g/kg")))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-74",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 629.8
  }, "0 g/kg")))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-75",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 669.8
  }, "0 g/kg")))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-76",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 690,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 690,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 709.8
  }, "0 g/kg")))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-77",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 749.8
  }, "0 g/kg")))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-78",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 789.8
  }, "0 g/kg")))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-79",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 810,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 810,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 829.8
  }, "0 g/kg")))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-80",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 869.8
  }, "0 g/kg")))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-81",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 909.8
  }, "0 g/kg")))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-82",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1240,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1240,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 1259.8
  }, "0 g/kg")))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-83",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 1299.8
  }, "0 g/kg")))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-84",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 940,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 940,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1338.5,
    y: 959.8
  }, "0 g/kg")))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-86",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 990,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 990,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1338.5,
    y: 1009.8
  }, "0 g/kg")))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-87",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1040,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1040,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1338.5,
    y: 1059.8
  }, "0 g/kg")))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-88",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1090,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1090,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1338.5,
    y: 1109.8
  }, "0 g/kg")))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-89",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1140,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1140,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1338.5,
    y: 1159.8
  }, "0 g/kg")))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-90",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1190,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1190,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 1209.8
  }, "0 g/kg")))), /*#__PURE__*/React.createElement("g", {
    id: "cell-bkvc-Qk19xin7eV_qB-f-128"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 110,
    width: 120,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 135,
      marginLeft: 1280
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b4 || (_b4 = /*#__PURE__*/React.createElement("b", null, "Totales diarios (d\xEDas de entreno)", /*#__PURE__*/React.createElement("br", null))))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 1339,
    y: 139,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Totales diarios (d\xEDa..."))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "cell-bkvc-Qk19xin7eV_qB-f-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1338.71 160 L 1338.71 183.63",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1338.71 188.88 L 1335.21 181.88 L 1338.71 183.63 L 1342.21 181.88 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "cell-iNM6wDF7hTtMBXn2YMH--1",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1320,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 1320,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1340.5,
    y: 1339.8
  }, "0 g/kg")))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-145",
    content: "<object label=\"\" units=\"g/kg\" data=\"postTraining\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g/kg",
    "data-data": "postTraining",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 80,
    width: 160,
    height: 1270,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-40",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 209.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 209.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 229.55
  }, "0 g/kg")))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-41",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 249.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 249.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 269.55
  }, "0 g/kg")))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-42",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 289.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 289.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 309.55
  }, "0 g/kg")))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-43",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 329.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 329.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 349.55
  }, "0 g/kg")))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-44",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 369.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 369.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 389.55
  }, "0 g/kg")))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-45",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 409.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 409.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 429.55
  }, "0 g/kg")))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-46",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 449.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 449.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 469.55
  }, "0 g/kg")))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-47",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 489.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 489.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 509.55
  }, "0 g/kg")))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-48",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 529.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 529.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 549.55
  }, "0 g/kg")))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-49",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 569.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 569.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 589.55
  }, "0 g/kg")))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-50",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 609.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 609.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 629.55
  }, "0 g/kg")))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-51",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 649.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 649.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 669.55
  }, "0 g/kg")))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-52",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 689.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 689.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 709.55
  }, "0 g/kg")))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-53",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 729.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 729.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 749.55
  }, "0 g/kg")))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-54",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 769.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 769.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 789.55
  }, "0 g/kg")))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-55",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 809.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 809.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 829.55
  }, "0 g/kg")))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-56",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 849.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 849.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 869.55
  }, "0 g/kg")))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-57",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 889.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 889.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 909.55
  }, "0 g/kg")))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-58",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 1239.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 1239.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 1259.55
  }, "0 g/kg")))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-59",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 1279.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1118,
    y: 1279.75,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1177.5,
    y: 1299.55
  }, "0 g/kg")))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-144"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1260 100 L 1255 100 Q 1250 100 1250 110 L 1250 130 Q 1250 140 1245 140 L 1242.5 140 Q 1240 140 1245 140 L 1247.5 140 Q 1250 140 1250 150 L 1250 170 Q 1250 180 1255 180 L 1260 180",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1250,140)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-87"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 110,
    width: 120,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 135,
      marginLeft: 1121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b5 || (_b5 = /*#__PURE__*/React.createElement("b", null, "Ingesta post-entreno")), " (al acabar de entrenar)")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1180,
    y: 139,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Ingesta post-entreno..."))))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1179.7 160 L 1179.7 183.63",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1179.7 188.88 L 1176.2 181.88 L 1179.7 183.63 L 1183.2 181.88 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-86",
    content: "<object label=\"\" units=\"g/h\" data=\"midTraining\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g/h",
    "data-data": "midTraining",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 80,
    width: 160,
    height: 1270,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-86"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 110.75,
    width: 120,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 136,
      marginLeft: 951
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b6 || (_b6 = /*#__PURE__*/React.createElement("b", null, "Ingesta intra-entreno")))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1010,
    y: 139,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Ingesta intra-entren..."))))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1009.7 160.75 L 1009.7 184.38",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1009.7 189.63 L 1006.2 182.63 L 1009.7 184.38 L 1013.2 182.63 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-23",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 250,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 250,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 269.8
  }, "0 g/h")))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-24",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 290,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 290,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 309.8
  }, "0 g/h")))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-25",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 389.8
  }, "0 g/h")))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-26",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 429.8
  }, "0 g/h")))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-27",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 509.8
  }, "0 g/h")))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-28",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 549.8
  }, "0 g/h")))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-29",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 589.8
  }, "0 g/h")))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-30",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 629.8
  }, "0 g/h")))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-31",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 669.8
  }, "0 g/h")))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-32",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 749.8
  }, "0 g/h")))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-33",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 789.8
  }, "0 g/h")))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-34",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 869.8
  }, "0 g/h")))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-35",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 909.8
  }, "0 g/h")))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-36",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 1009.5,
    y: 1299.8
  }, "0 g/h")))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-0",
    content: "<object label=\"\" units=\"g/kg\" data=\"preTraining\" nodeType=\"container\"/>",
    "data-label": "",
    "data-units": "g/kg",
    "data-data": "preTraining",
    "data-node-type": "container"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 80,
    width: 160,
    height: 1270,
    fill: "none",
    stroke: "#cccccc",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 839.66 160 L 839.66 183.63",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 839.66 188.88 L 836.16 181.88 L 839.66 183.63 L 843.16 181.88 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 285.1,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 285.1 L 773 285.1 L 773 325.1 L 793 325.1",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 325.1,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 325.1 L 773 325.1 L 773 365.1 L 793 365.1",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 445.2,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 445.2 L 773 445.2 L 773 485.2 L 793 485.2",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 485.2,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 485.2 L 773 485.2 L 773 525.2 L 793 525.2",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 365.1,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 365.1 L 773 365.1 L 773 405.1 L 793 405.1",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 405.1,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 405.1 L 773 405.1 L 773 445.1 L 793 445.1",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 605.3,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 605.3 L 773 605.3 L 773 645.3 L 793 645.3",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 645.3,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 645.3 L 773 645.3 L 773 685.3 L 793 685.3",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 765.4,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 765.4 L 773 765.4 L 773 805.4 L 793 805.4",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 805.4,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 805.4 L 773 805.4 L 773 845.4 L 793 845.4",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 685.3,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 685.3 L 773 685.3 L 773 725.3 L 793 725.3",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 725.3,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 725.3 L 773 725.3 L 773 765.3 L 793 765.3",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 525.2,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 525.2 L 773 525.2 L 773 565.2 L 793 565.2",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 565.2,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 565.2 L 773 565.2 L 773 605.2 L 793 605.2",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-85"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 110,
    width: 120,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 135,
      marginLeft: 781
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b7 || (_b7 = /*#__PURE__*/React.createElement("b", null, "Ingesta pre-entreno")), " (3-4 horas antes)")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 840,
    y: 139,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Ingesta pre-entreno..."))))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 205,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 205 L 773 205 L 773 245 L 793 245",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-143"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 95,
    width: 20,
    height: 80,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 95 L 773 95 L 773 175 L 793 175",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 245,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 245 L 773 245 L 773 285 L 793 285",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 845,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 845 L 773 845 L 773 885 L 793 885",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 885,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 885 L 773 885 L 773 925 L 793 925",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-284"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 1235.1,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 1235.1 L 773 1235.1 L 773 1275.1 L 793 1275.1",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-285"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 1275.1,
    width: 20,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 793 1275.1 L 773 1275.1 L 773 1315.1 L 793 1315.1",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-0",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\" label=\"0\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": "",
    "data-label": 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 210,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 210,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 229.8
  }, "0 g/kg")))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-1",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 250,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 250,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 269.8
  }, "0 g/kg")))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-2",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 290,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 290,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 309.8
  }, "0 g/kg")))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-3",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 330,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 330,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 349.8
  }, "0 g/kg")))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-4",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 370,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 389.8
  }, "0 g/kg")))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-5",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 410,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 429.8
  }, "0 g/kg")))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-6",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 450,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 450,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 469.8
  }, "0 g/kg")))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-7",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 490,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 509.8
  }, "0 g/kg")))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-8",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 530,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 549.8
  }, "0 g/kg")))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-9",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 570,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 589.8
  }, "0 g/kg")))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-10",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 610,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 629.8
  }, "0 g/kg")))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-11",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 650,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 669.8
  }, "0 g/kg")))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-12",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 690,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 690,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 709.8
  }, "0 g/kg")))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-13",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 730,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 749.8
  }, "0 g/kg")))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-14",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 770,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 789.8
  }, "0 g/kg")))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-15",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 810,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 810,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 829.8
  }, "0 g/kg")))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-16",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 850,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 869.8
  }, "0 g/kg")))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-17",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 890,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 909.8
  }, "0 g/kg")))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-18",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1240,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1240,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 1259.8
  }, "0 g/kg")))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Eee3tdoydsrU2995XE2H-19",
    content: "<object placeholder=\"value\" value=\"0\" placeholders=\"1\" nodeType=\"dataNode\" tooltip=\"\"/>",
    "data-placeholder": "value",
    "data-value": 0,
    "data-placeholders": 1,
    "data-node-type": "dataNode",
    "data-tooltip": ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 1280,
    width: 120,
    height: 30,
    rx: 3,
    ry: 3,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#393C56",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12.6px"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("text", {
    x: 839.5,
    y: 1299.8
  }, "0 g/kg")))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 1194.26 L 530 1199.13 Q 530 1204 540 1204.07 L 612.63 1204.55",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 1204.59 L 610.86 1208.04 L 612.63 1204.55 L 610.91 1201.04 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 1164.26 L 530 1159.63 Q 530 1155 540 1155 L 612.63 1155",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 1155 L 610.88 1158.5 L 612.63 1155 L 610.88 1151.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 1095 L 530 1100 Q 530 1105 540 1105 L 613.63 1105",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 1105 L 611.88 1108.5 L 613.63 1105 L 611.88 1101.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 1065 L 530 1060 Q 530 1055 540 1055 L 612.63 1055",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 1055 L 610.88 1058.5 L 612.63 1055 L 610.88 1051.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 993.99 L 530 998.89 Q 530 1003.8 540 1003.88 L 612.63 1004.47",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 1004.51 L 610.85 1007.95 L 612.63 1004.47 L 610.91 1000.95 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-fmSpTnI5OuKCVyeSI9iZ-9",
    content: "<object label=\"Hidratos\" data=\"hydrates\" nodeType=\"baseNode\" tooltip=\"\"/>",
    "data-label": "Hidratos",
    "data-data": "hydrates",
    "data-node-type": "baseNode",
    "data-tooltip": ""
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 730,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 745,
      marginLeft: 151
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Hidratos")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 749,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Hidratos"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-fmSpTnI5OuKCVyeSI9iZ-204",
    content: "<object label=\"Macronutrientes\" nodeType=\"root\" tooltip=\"\" data=\"nutrients\"/>",
    "data-label": "Macronutrientes",
    "data-node-type": "root",
    "data-tooltip": "",
    "data-data": "nutrients"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 1080,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 1095,
      marginLeft: 21
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Macronutrientes")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 1099,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Macronutrientes"))))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "cell-fmSpTnI5OuKCVyeSI9iZ-257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 1080 L 80 755 Q 80 745 90 745 L 143.63 745",
    fill: "none",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 148.88 745 L 141.88 748.5 L 143.63 745 L 141.88 741.5 Z",
    fill: "#e07a5f",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-rbdL9r2mSI0Ib-DJEuMh-0",
    content: "<object label=\"CROSSFIT BAJAR GRASA CORPORAL \" nodeType=\"title\" tooltip=\"\"/>",
    "data-label": "CROSSFIT BAJAR GRASA CORPORAL ",
    "data-node-type": "title",
    "data-tooltip": ""
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 60,
    width: 230,
    height: 40,
    rx: 6,
    ry: 6,
    fillOpacity: 0.9,
    fill: "#d0cee2",
    stroke: "#56517e",
    strokeOpacity: 0.9,
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 228,
      height: 1,
      paddingTop: 80,
      marginLeft: 322
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "CROSSFIT BAJAR GRASA CORPORAL ")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 84,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    fontWeight: "bold"
  }, "CROSSFIT BAJAR GRASA CORPORAL "))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-LLuILno9xEbZuQGBvMct-3",
    content: "<object label=\"Prote\\xEDna\" data=\"protein\" nodeType=\"baseNode\" tooltip=\"\"/>",
    "data-label": "Prote\\xEDna",
    "data-data": "protein",
    "data-node-type": "baseNode",
    "data-tooltip": ""
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 1280,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 1295,
      marginLeft: 161
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Prote\xEDna")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 1299,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Prote\xEDna"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-LLuILno9xEbZuQGBvMct-4",
    content: "<object label=\"Grasas\" data=\"fat\" nodeType=\"baseNode\" tooltip=\"\"/>",
    "data-label": "Grasas",
    "data-data": "fat",
    "data-node-type": "baseNode",
    "data-tooltip": ""
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 1384.04,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 1399,
      marginLeft: 161
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Grasas")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 1403,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Grasas"))))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 280 1474.9 L 780 1475.1",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-LLuILno9xEbZuQGBvMct-5",
    content: "<object label=\"Fibra\" data=\"fiber\" nodeType=\"baseNode\" tooltip=\"\"/>",
    "data-label": "Fibra",
    "data-data": "fiber",
    "data-node-type": "baseNode",
    "data-tooltip": ""
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 1459.88,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title6 || (_title6 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 1475,
      marginLeft: 161
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Fibra")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 1478,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Fibra"))))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 1295 L 780 1295",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 1255 L 780 1255",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 749 1334.94 L 780 1334.91",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-283"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 749 1335 L 1276.63 1334.9",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1281.88 1334.9 L 1274.88 1338.4 L 1276.63 1334.9 L 1274.88 1331.4 Z",
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "cell-iNM6wDF7hTtMBXn2YMH--2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 1335 L 1281 1335",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 1375 L 780 1375",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 1425.01 L 780 1425.03",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 340 370 L 340 275 Q 340 265 350 265 L 463.63 265",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 265 L 461.88 268.5 L 463.63 265 L 461.88 261.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 400 385 L 463.63 385",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 385 L 461.88 388.5 L 463.63 385 L 461.88 381.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 340 400 L 340 495 Q 340 505 350 505 L 463.63 505",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 505 L 461.88 508.5 L 463.63 505 L 461.88 501.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 224.75 L 780 224.85",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 304.75 L 780 304.85",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 280 L 530 295 Q 530 305 540 304.97 L 613.63 304.77",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 304.75 L 611.89 308.27 L 613.63 304.77 L 611.87 301.27 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 264.84 L 780 264.91",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 250 L 530 235 Q 530 225 540 224.97 L 613.63 224.77",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 224.75 L 611.89 228.27 L 613.63 224.77 L 611.87 221.27 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 344.75 L 780 344.85",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 425 L 780 425",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 590 385 L 612.63 385",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 385 L 610.88 388.5 L 612.63 385 L 610.88 381.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 400 L 530 415 Q 530 425 540 425 L 613.63 425",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 425 L 611.88 428.5 L 613.63 425 L 611.88 421.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 385 L 780 385",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 370 L 530 355 Q 530 345 540 344.97 L 613.63 344.77",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 344.75 L 611.89 348.27 L 613.63 344.77 L 611.87 341.27 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 590 265 L 612.63 264.8",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 264.76 L 610.91 268.32 L 612.63 264.8 L 610.85 261.32 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-1",
    content: "<object label=\"Intensidad baja (tecnico)\" data=\"LI\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Intensidad baja (tecnico)",
    "data-data": "LI",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 250,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title7 || (_title7 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 265,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Intensidad baja (tecnico)")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 269,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Intensidad baja (tec..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-0",
    content: "<object label=\"Intensidad alta\" data=\"HI\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Intensidad alta",
    "data-data": "HI",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 370,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title8 || (_title8 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 385,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Intensidad alta")))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 389,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Intensidad alta"))))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 465 L 780 465",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 590 505 L 612.63 505",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 505 L 610.88 508.5 L 612.63 505 L 610.88 501.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 505 L 780 505",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 490 L 530 475 Q 530 465 540 465 L 613.63 465",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 465 L 611.88 468.5 L 613.63 465 L 611.88 461.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-L7sAQhL4vrxA67ggb6H0-3",
    content: "<object label=\"Entrenamiento de fuerza\" data=\"ST\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Entrenamiento de fuerza",
    "data-data": "ST",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 490,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title9 || (_title9 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 505,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Entrenamiento de fuerza")))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 509,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Entrenamiento de fue..."))))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 545 L 780 545",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 520 L 530 535 Q 530 545 540 545 L 613.63 545",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 545 L 611.88 548.5 L 613.63 545 L 611.88 541.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 350 730 L 350 635 Q 350 625 360 625 L 463.63 625",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 625 L 461.88 628.5 L 463.63 625 L 461.88 621.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-174"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 410 745 L 463.63 745",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 745 L 461.88 748.5 L 463.63 745 L 461.88 741.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 350 760 L 350 855 Q 350 865 360 865 L 463.63 865",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 865 L 461.88 868.5 L 463.63 865 L 461.88 861.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 585 L 780 585",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 665 L 780 665",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 640 L 530 655 Q 530 665 540 665 L 613.63 665",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 665 L 611.88 668.5 L 613.63 665 L 611.88 661.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 625 L 780 625",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 610 L 530 595 Q 530 585 540 585 L 612.63 585",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 585 L 610.88 588.5 L 612.63 585 L 610.88 581.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 705 L 780 705",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 785 L 780 785",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 590 745 L 613.63 745",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 745 L 611.88 748.5 L 613.63 745 L 611.88 741.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-185"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 760 L 530 775 Q 530 785 540 785 L 613.63 785",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 785 L 611.88 788.5 L 613.63 785 L 611.88 781.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 745 L 760 745 L 780 745",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 730 L 530 715 Q 530 705 540 705 L 613.63 705",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 705 L 611.88 708.5 L 613.63 705 L 611.88 701.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 590 625 L 613.63 625",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 625 L 611.88 628.5 L 613.63 625 L 611.88 621.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-191",
    content: "<object label=\"Intensidad baja (tecnico)\" data=\"LI\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Intensidad baja (tecnico)",
    "data-data": "LI",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 610,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title10 || (_title10 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 625,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Intensidad baja (tecnico)")))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 629,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Intensidad baja (tec..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-192",
    content: "<object label=\"Intensidad alta\" data=\"HI\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Intensidad alta",
    "data-data": "HI",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 730,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title11 || (_title11 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 745,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Intensidad alta")))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 749,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Intensidad alta"))))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 825 L 780 825",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-194"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 590 865 L 613.63 865",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 865 L 611.88 868.5 L 613.63 865 L 611.88 861.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 865 L 780 865",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 850 L 530 835 Q 530 825 540 825 L 612.63 825",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 825 L 610.88 828.5 L 612.63 825 L 610.88 821.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-197",
    content: "<object label=\"Entrenamiento de fuerza\" data=\"ST\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Entrenamiento de fuerza",
    "data-data": "ST",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 850,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title12 || (_title12 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 865,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Entrenamiento de fuerza")))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 869,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Entrenamiento de fue..."))))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 905 L 780 905",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-199"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 880 L 530 895 Q 530 905 540 905 L 613.63 905",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 905 L 611.88 908.5 L 613.63 905 L 611.88 901.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-PI7-VOyyga1k_dtWJKXn-89"
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 20,
    width: 800,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 798,
      height: 1,
      paddingTop: 45,
      marginLeft: 761
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b8 || (_b8 = /*#__PURE__*/React.createElement("b", null, "1 entrenamiento")))))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 49,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "1 entrenamiento"))))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 385 L 943.63 385",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 385 L 941.88 388.5 L 943.63 385 L 941.88 381.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 665 L 943.63 665",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 665 L 941.88 668.5 L 943.63 665 L 941.88 661.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 745 L 943.63 745",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 745 L 941.88 748.5 L 943.63 745 L 941.88 741.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 1375 L 1113.63 1375",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1118.88 1375 L 1111.88 1378.5 L 1113.63 1375 L 1111.88 1371.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 1475.1 L 1113.63 1475.02",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1118.88 1475.02 L 1111.88 1478.52 L 1113.63 1475.02 L 1111.88 1471.52 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 1255 L 1111.63 1254.76",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 1254.75 L 1109.89 1258.26 L 1111.63 1254.76 L 1109.88 1251.26 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 1425.04 L 1113.63 1424.92",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1118.88 1424.92 L 1111.88 1428.42 L 1113.63 1424.92 L 1111.88 1421.42 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 585 L 943.63 585",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 585 L 941.88 588.5 L 943.63 585 L 941.88 581.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 625 L 943.63 625",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 625 L 941.88 628.5 L 943.63 625 L 941.88 621.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 210 L 1264 210 Q 1259 210 1259 217.5 L 1259 221.25 Q 1259 225 1254 225 L 1251.5 225 Q 1249 225 1254 225 L 1256.5 225 Q 1259 225 1259 232.5 L 1259 236.25 Q 1259 240 1264 240 L 1269 240",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,225)",
    pointerEvents: "all"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 545 L 943.63 545",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 545 L 941.88 548.5 L 943.63 545 L 941.88 541.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 250 L 1264 250 Q 1259 250 1259 257.5 L 1259 261.25 Q 1259 265 1254 265 L 1251.5 265 Q 1249 265 1254 265 L 1256.5 265 Q 1259 265 1259 272.5 L 1259 276.25 Q 1259 280 1264 280 L 1269 280",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,265)",
    pointerEvents: "all"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-146"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 290 L 1264 290 Q 1259 290 1259 297.5 L 1259 301.25 Q 1259 305 1254 305 L 1251.5 305 Q 1249 305 1254 305 L 1256.5 305 Q 1259 305 1259 312.5 L 1259 316.25 Q 1259 320 1264 320 L 1269 320",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,305)",
    pointerEvents: "all"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 330 L 1264 330 Q 1259 330 1259 337.5 L 1259 341.25 Q 1259 345 1254 345 L 1251.5 345 Q 1249 345 1254 345 L 1256.5 345 Q 1259 345 1259 352.5 L 1259 356.25 Q 1259 360 1264 360 L 1269 360",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,345)",
    pointerEvents: "all"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 370 L 1264 370 Q 1259 370 1259 377.5 L 1259 381.25 Q 1259 385 1254 385 L 1251.5 385 Q 1249 385 1254 385 L 1256.5 385 Q 1259 385 1259 392.5 L 1259 396.25 Q 1259 400 1264 400 L 1269 400",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,385)",
    pointerEvents: "all"
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 410 L 1264 410 Q 1259 410 1259 417.5 L 1259 421.25 Q 1259 425 1254 425 L 1251.5 425 Q 1249 425 1254 425 L 1256.5 425 Q 1259 425 1259 432.5 L 1259 436.25 Q 1259 440 1264 440 L 1269 440",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,425)",
    pointerEvents: "all"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 450 L 1264 450 Q 1259 450 1259 457.5 L 1259 461.25 Q 1259 465 1254 465 L 1251.5 465 Q 1249 465 1254 465 L 1256.5 465 Q 1259 465 1259 472.5 L 1259 476.25 Q 1259 480 1264 480 L 1269 480",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,465)",
    pointerEvents: "all"
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 491 L 1264 491 Q 1259 491 1259 498.5 L 1259 502.25 Q 1259 506 1254 506 L 1251.5 506 Q 1249 506 1254 506 L 1256.5 506 Q 1259 506 1259 513.5 L 1259 517.25 Q 1259 521 1264 521 L 1269 521",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,506)",
    pointerEvents: "all"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 530 L 1264 530 Q 1259 530 1259 537.5 L 1259 541.25 Q 1259 545 1254 545 L 1251.5 545 Q 1249 545 1254 545 L 1256.5 545 Q 1259 545 1259 552.5 L 1259 556.25 Q 1259 560 1264 560 L 1269 560",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,545)",
    pointerEvents: "all"
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 570 L 1264 570 Q 1259 570 1259 577.5 L 1259 581.25 Q 1259 585 1254 585 L 1251.5 585 Q 1249 585 1254 585 L 1256.5 585 Q 1259 585 1259 592.5 L 1259 596.25 Q 1259 600 1264 600 L 1269 600",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,585)",
    pointerEvents: "all"
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 610 L 1264 610 Q 1259 610 1259 617.5 L 1259 621.25 Q 1259 625 1254 625 L 1251.5 625 Q 1249 625 1254 625 L 1256.5 625 Q 1259 625 1259 632.5 L 1259 636.25 Q 1259 640 1264 640 L 1269 640",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,625)",
    pointerEvents: "all"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-155"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 650 L 1264 650 Q 1259 650 1259 657.5 L 1259 661.25 Q 1259 665 1254 665 L 1251.5 665 Q 1249 665 1254 665 L 1256.5 665 Q 1259 665 1259 672.5 L 1259 676.25 Q 1259 680 1264 680 L 1269 680",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,665)",
    pointerEvents: "all"
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 690 L 1264 690 Q 1259 690 1259 697.5 L 1259 701.25 Q 1259 705 1254 705 L 1251.5 705 Q 1249 705 1254 705 L 1256.5 705 Q 1259 705 1259 712.5 L 1259 716.25 Q 1259 720 1264 720 L 1269 720",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,705)",
    pointerEvents: "all"
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 730 L 1264 730 Q 1259 730 1259 737.5 L 1259 741.25 Q 1259 745 1254 745 L 1251.5 745 Q 1249 745 1254 745 L 1256.5 745 Q 1259 745 1259 752.5 L 1259 756.25 Q 1259 760 1264 760 L 1269 760",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,745)",
    pointerEvents: "all"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 770 L 1264 770 Q 1259 770 1259 777.5 L 1259 781.25 Q 1259 785 1254 785 L 1251.5 785 Q 1249 785 1254 785 L 1256.5 785 Q 1259 785 1259 792.5 L 1259 796.25 Q 1259 800 1264 800 L 1269 800",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,785)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-193",
    content: "<object label=\"Sedentario\" data=\"S\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Sedentario",
    "data-data": "S",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 370,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title13 || (_title13 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 385,
      marginLeft: 281
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Sedentario")))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 389,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Sedentario"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-9AzoxPZb5V4e6e_m3DvJ-97",
    content: "<object label=\"No sedentario\" data=\"NS\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "No sedentario",
    "data-data": "NS",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 730,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title14 || (_title14 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 745,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "No sedentario")))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 749,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "No sedentario"))))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-220"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 210 730 L 210 395 Q 210 385 220 385 L 273.63 385",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 278.88 385 L 271.88 388.5 L 273.63 385 L 271.88 381.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 1110 L 80 1465 Q 80 1475 90 1474.99 L 153.63 1474.89",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 158.88 1474.88 L 151.89 1478.39 L 153.63 1474.89 L 151.88 1471.39 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 1110 L 80 1285 Q 80 1295 90 1295 L 153.63 1295",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 158.88 1295 L 151.88 1298.5 L 153.63 1295 L 151.88 1291.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-224"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 1110 L 80 1390 Q 80 1400 90 1399.88 L 153.63 1399.12",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 158.88 1399.05 L 151.92 1402.64 L 153.63 1399.12 L 151.84 1395.64 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 220 1384.04 L 220 1379.52 Q 220 1375 230 1375 L 613.63 1375",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 1375 L 611.88 1378.5 L 613.63 1375 L 611.88 1371.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vS4X0i97-ZryPgSZAwrO-229"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 220 1414.04 L 220 1419.52 Q 220 1425 230 1425 L 613.63 1425",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 1425 L 611.88 1428.5 L 613.63 1425 L 611.88 1421.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    id: "cell-79-CoWxSw2Dl3x5ap4GN-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 220 1280 L 220 1265 Q 220 1255 230 1255 L 613.63 1255",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 1255 L 611.88 1258.5 L 613.63 1255 L 611.88 1251.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    id: "cell-79-CoWxSw2Dl3x5ap4GN-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 280 1295 L 612.63 1295",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 1295 L 610.88 1298.5 L 612.63 1295 L 610.88 1291.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    id: "cell-79-CoWxSw2Dl3x5ap4GN-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 220 1310 L 220 1325 Q 220 1335 230 1335 L 612.63 1335",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 1335 L 610.88 1338.5 L 612.63 1335 L 610.88 1331.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-0"
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 20,
    width: 560,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#92e884",
    stroke: "#299130",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 558,
      height: 1,
      paddingTop: 45,
      marginLeft: 1591
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b9 || (_b9 = /*#__PURE__*/React.createElement("b", null, "2-3 entrenamientos diarios", /*#__PURE__*/React.createElement("br", null))))))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 49,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2-3 entrenamientos diarios&#xa;"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-1"
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 200,
    width: 440,
    height: 130,
    rx: 19.5,
    ry: 19.5,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 438,
      height: 1,
      paddingTop: 265,
      marginLeft: 1651
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "c")))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 269,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "c"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-3"
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 260,
    width: 400,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#fad9d5",
    stroke: "#fad9d5",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 290,
      marginLeft: 1671
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "N\xFAmero de horas totales"))))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 293,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "N\xFAmero de horas totales"))))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1869.5 150.92 L 1869.5 174.55",
    fill: "none",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1869.5 179.8 L 1866 172.8 L 1869.5 174.55 L 1873 172.8 Z",
    fill: "#e07a5f",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1680 267.44 L 2070 267.44",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-14"
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1810,
    y: 100,
    width: 120,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 125,
      marginLeft: 1811
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b10 || (_b10 = /*#__PURE__*/React.createElement("b", null, "Totales diarios (d\xEDas de entreno)", /*#__PURE__*/React.createElement("br", null))))))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 129,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Totales diarios (d\xEDa..."))))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 420,
    width: 560,
    height: 130,
    rx: 19.5,
    ry: 19.5,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-17"
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 480,
    width: 400,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 510,
      marginLeft: 1621
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "N\xFAmero de horas totales diarias entrenadas", _br || (_br = /*#__PURE__*/React.createElement("br", null))))))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1820,
    y: 513,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "N\xFAmero de horas totales diarias entrenadas&#xa;"))))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1636 492.14 L 2026 492.14",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1869.5 383.09 L 1869.5 406.72",
    fill: "none",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1869.5 411.97 L 1866 404.97 L 1869.5 406.72 L 1873 404.97 Z",
    fill: "#e07a5f",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-20"
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1810,
    y: 340,
    width: 120,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 365,
      marginLeft: 1811
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b11 || (_b11 = /*#__PURE__*/React.createElement("b", null, "Totales diarios (")), _b12 || (_b12 = /*#__PURE__*/React.createElement("b", null, "resto de d\xEDas")), _b13 || (_b13 = /*#__PURE__*/React.createElement("b", null, ")")))))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 369,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Totales diarios (res..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-2"
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 210,
    width: 400,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fad9d5",
    stroke: "#fad9d5",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 235,
      marginLeft: 1671
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center",
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "(Hidratos totales n\xFAmero de horas totales entrenadas x horas del primer entrenamiento) + (Hidratos totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xFAmero de horas totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del segundo entrenamiento)")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)))))))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 238,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "(Hidratos totales n\xFAmero de horas totales entrenadas x horas del primer entrenamiento) +..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-16"
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1630,
    y: 430,
    width: 400,
    height: 60,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 460,
      marginLeft: 1631
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center",
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center"
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "(Hidratos totales n\xFAmero de horas totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del primer entrenamiento) + (Hidratos totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xFAmero de horas totales")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  })), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del segundo entrenamiento)")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null))))))))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 1830,
    y: 463,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "(Hidratos totales n\xFAmero de horas totales entrenadas  x horas del primer entrenamiento)..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-77"
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 929.79,
    width: 440,
    height: 130,
    rx: 19.5,
    ry: 19.5,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 438,
      height: 1,
      paddingTop: 995,
      marginLeft: 1651
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "c")))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 998,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "c"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-78"
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 989.79,
    width: 400,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#fad9d5",
    stroke: "#fad9d5",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 1020,
      marginLeft: 1681
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "N\xFAmero de horas totales"))))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 1880,
    y: 1022,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "N\xFAmero de horas totales"))))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1685 1004.23 L 2075 1004.23",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-82"
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 1069.79,
    width: 440,
    height: 130,
    rx: 19.5,
    ry: 19.5,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 438,
      height: 1,
      paddingTop: 1135,
      marginLeft: 1651
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "c")))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 1138,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "c"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-83"
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 1134.05,
    width: 400,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 1164,
      marginLeft: 1671
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "N\xFAmero de horas totales"))))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 1167,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "N\xFAmero de horas totales"))))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1680 1139.59 L 2070 1139.59",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-87"
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 939.79,
    width: 400,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#fad9d5",
    stroke: "#fad9d5",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 970,
      marginLeft: 1681
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center",
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "(Prote\xEDnas totales n\xFAmero de horas totales")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del primer entrenamiento) + (")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "Prote\xEDnas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xFAmero de horas totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del segundo entrenamiento)")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null)))))))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 1880,
    y: 972,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "(Prote\xEDnas totales n\xFAmero de horas totales entrenadas  x horas del primer entrenamiento)..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-88"
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 1084.05,
    width: 400,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 1109,
      marginLeft: 1671
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center",
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center"
  }, /*#__PURE__*/React.createElement("div", {
    align: "center",
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "(Prote\xEDnas totales n\xFAmero de horas totales")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del primer entrenamiento) + (")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "Prote\xEDnas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xFAmero de horas totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del segundo entrenamiento)")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }))))))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 1112,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "(Prote\xEDnas totales n\xFAmero de horas totales entrenadas  x horas del primer entrenamiento)..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-90"
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 1209.79,
    width: 440,
    height: 130,
    rx: 19.5,
    ry: 19.5,
    fill: "#fad9d5",
    stroke: "#f26d68",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 438,
      height: 1,
      paddingTop: 1275,
      marginLeft: 1651
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "c")))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 1278,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "c"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-91"
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1675,
    y: 1269.79,
    width: 400,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fad9d5",
    stroke: "#fad9d5",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 1295,
      marginLeft: 1676
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "N\xFAmero de horas totales"))))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 1875,
    y: 1297,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "N\xFAmero de horas totales"))))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1675 1279.08 L 2065 1279.08",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-93"
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 1349.04,
    width: 440,
    height: 130,
    rx: 19.5,
    ry: 19.5,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 438,
      height: 1,
      paddingTop: 1414,
      marginLeft: 1651
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #393C56; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(57, 60, 86)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "c")))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 1418,
    fill: "#393C56",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "c"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-94"
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1675,
    y: 1399.79,
    width: 400,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 1430,
      marginLeft: 1676
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "N\xFAmero de horas totales"))))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 1875,
    y: 1432,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "N\xFAmero de horas totales"))))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1675 1413.68 L 2065 1413.68",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-96"
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 1219.79,
    width: 400,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fad9d5",
    stroke: "#fad9d5",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 1245,
      marginLeft: 1671
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center",
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "(Grasas totales n\xFAmero de horas totales")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del primer entrenamiento) + (")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "Grasas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xFAmero de horas totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del segundo entrenamiento)")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null)))))))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 1247,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "(Grasas totales n\xFAmero de horas totales entrenadas  x horas del primer entrenamiento) +..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-HNGBsHO-O6C0feMs7NwE-97"
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 1350.04,
    width: 400,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 1380,
      marginLeft: 1671
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center",
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "(Grasas totales n\xFAmero de horas totales")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del primer entrenamiento) + (")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "Grasas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xFAmero de horas totales ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "entrenadas ")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, " x horas del segundo entrenamiento)")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br7 || (_br7 = /*#__PURE__*/React.createElement("br", null)))))))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 1383,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "(Grasas totales n\xFAmero de horas totales entrenadas  x horas del primer entrenamiento) +..."))))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1645,
    y: 590,
    width: 450,
    height: 120,
    rx: 18,
    ry: 18,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-2"
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 640,
    width: 400,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 670,
      marginLeft: 1671
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "N\xFAmero de horas totales semanales entrenadas", _br8 || (_br8 = /*#__PURE__*/React.createElement("br", null))))))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 673,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "N\xFAmero de horas totales semanales entrenadas&#xa;"))))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1675 650 L 2065 650",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-4"
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 600,
    width: 400,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 398,
      height: 1,
      paddingTop: 620,
      marginLeft: 1671
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center",
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    align: "center"
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "(a x n\xBA1) + (b x n\xBA2) + (c x n\xBA3) + (....)")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br9 || (_br9 = /*#__PURE__*/React.createElement("br", null))))))))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 623,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "(a x n\xBA1) + (b x n\xBA2) + (c x n\xBA3) + (....)"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-8"
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 2030,
    y: 460,
    width: 90,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#bac8d3",
    stroke: "#bac8d3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 490,
      marginLeft: 2031
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "a, b,c"))))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 2075,
    y: 493,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "a, b,c"))))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2032 494 L 2052 494",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2032 489 L 2052 489",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-9"
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 730,
    width: 400,
    height: 110,
    rx: 16.5,
    ry: 16.5,
    fill: "#bac8d3",
    stroke: "#23445d",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 402,
      height: 1,
      paddingTop: 785,
      marginLeft: 1669
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br10 || (_br10 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br11 || (_br11 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br12 || (_br12 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br13 || (_br13 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "a = hidratos totales n\xFAmero de horas de entrenamiento d\xEDa 1 ", _br14 || (_br14 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xBA1 = horas entrenadas d\xEDa 1 ", _br15 || (_br15 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "b = hidratos totales n\xFAmero de horas de entrenamiento d\xEDa 2 ", _br16 || (_br16 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xBA2 = horas entrenadas d\xEDa 2 ", _br17 || (_br17 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "c = hidratos totales n\xFAmero de horas de entrenamiento d\xEDa 3 ", _br18 || (_br18 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "n\xBA3 = horas entrenadas d\xEDa 3 ", _br19 || (_br19 = /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br20 || (_br20 = /*#__PURE__*/React.createElement("br", null)), _br21 || (_br21 = /*#__PURE__*/React.createElement("br", null)))))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, _br22 || (_br22 = /*#__PURE__*/React.createElement("br", null)))))))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 1870,
    y: 788,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "a = hidratos totales n\xFAmero de horas de entrenamiento d\xEDa 1..."))))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    id: "cell-4AIRkcCpCIsq9uTrHQMN-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1869.64 550 L 1869.64 573.63",
    fill: "none",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1869.64 578.88 L 1866.14 571.88 L 1869.64 573.63 L 1873.14 571.88 Z",
    fill: "#e07a5f",
    stroke: "#e07a5f",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-1",
    content: "<object label=\"Intensidad alta\" data=\"HI\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Intensidad alta",
    "data-data": "HI",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 1065,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title15 || (_title15 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 1080,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Intensidad alta")))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 1084,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Intensidad alta"))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-2",
    content: "<object label=\"Entrenamiento de fuerza\" data=\"ST\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Entrenamiento de fuerza",
    "data-data": "ST",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 1164.26,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title16 || (_title16 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 1179,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Entrenamiento de fuerza")))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 1183,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Entrenamiento de fue..."))))), /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-3",
    content: "<object label=\"No sedentario horas extra\" data=\"EH\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "No sedentario horas extra",
    "data-data": "EH",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 1065,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title17 || (_title17 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 1080,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "No sedentario horas extra")))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 1084,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "No sedentario horas..."))))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-272"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 955 L 1279 955",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-274"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 1055 L 1279 1055",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-277"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 1155 L 1279 1155",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-273"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 1005 L 1279 1005",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-275"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 740 1105 L 1279 1105",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-279"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 739 1205 L 1281 1205",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 963.99 L 530 959.39 Q 530 954.8 540 954.81 L 612.63 954.91",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 617.88 954.92 L 610.88 958.41 L 612.63 954.91 L 610.89 951.41 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-0",
    content: "<object label=\"Intensidad baja (tecnico)\" data=\"LI\" nodeType=\"intermediateNode\" tooltip=\"\"/>",
    "data-label": "Intensidad baja (tecnico)",
    "data-data": "LI",
    "data-node-type": "intermediateNode",
    "data-tooltip": ""
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 963.99,
    width: 120,
    height: 30,
    rx: 4.5,
    ry: 4.5,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("title", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, _title18 || (_title18 = /*#__PURE__*/React.createElement("title", null)), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 979,
      marginLeft: 471
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Intensidad baja (tecnico)")))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 983,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Intensidad baja (tec..."))))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 270 745 L 283.63 745",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.88 745 L 281.88 748.5 L 283.63 745 L 281.88 741.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 210 760 L 210 1070 Q 210 1080 220 1080 L 283.63 1080",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.88 1080 L 281.88 1083.5 L 283.63 1080 L 281.88 1076.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 350 1065 L 350 989 Q 350 979 360 979 L 463.63 978.99",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 978.99 L 461.88 982.49 L 463.63 978.99 L 461.88 975.49 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 410 1080 L 463.63 1080",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 1080 L 461.88 1083.5 L 463.63 1080 L 461.88 1076.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    id: "cell-lyc6dbXZRqTSNiJwyJpd-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 350 1095 L 350 1170 Q 350 1180 360 1179.94 L 463.63 1179.3",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.88 1179.27 L 461.9 1182.81 L 463.63 1179.3 L 461.86 1175.81 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vdCYvkkWKKJacyBxWsYt-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 1240 L 1264 1240 Q 1259 1240 1259 1247.5 L 1259 1251.25 Q 1259 1255 1254 1255 L 1251.5 1255 Q 1249 1255 1254 1255 L 1256.5 1255 Q 1259 1255 1259 1262.5 L 1259 1266.25 Q 1259 1270 1264 1270 L 1269 1270",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,1255)",
    pointerEvents: "all"
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vdCYvkkWKKJacyBxWsYt-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 1280 L 1264 1280 Q 1259 1280 1259 1287.5 L 1259 1291.25 Q 1259 1295 1254 1295 L 1251.5 1295 Q 1249 1295 1254 1295 L 1256.5 1295 Q 1259 1295 1259 1302.5 L 1259 1306.25 Q 1259 1310 1264 1310 L 1269 1310",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,1295)",
    pointerEvents: "all"
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vdCYvkkWKKJacyBxWsYt-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1270 1360 L 1265 1360 Q 1260 1360 1260 1367.5 L 1260 1371.25 Q 1260 1375 1255 1375 L 1252.5 1375 Q 1250 1375 1255 1375 L 1257.5 1375 Q 1260 1375 1260 1382.5 L 1260 1386.25 Q 1260 1390 1265 1390 L 1270 1390",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1260,1375)",
    pointerEvents: "all"
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vdCYvkkWKKJacyBxWsYt-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1270 1410 L 1265 1410 Q 1260 1410 1260 1417.5 L 1260 1421.25 Q 1260 1425 1255 1425 L 1252.5 1425 Q 1250 1425 1255 1425 L 1257.5 1425 Q 1260 1425 1260 1432.5 L 1260 1436.25 Q 1260 1440 1265 1440 L 1270 1440",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1260,1425)",
    pointerEvents: "all"
  }))), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    id: "cell-vdCYvkkWKKJacyBxWsYt-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1270 1459.88 L 1265 1459.88 Q 1260 1459.88 1260 1467.38 L 1260 1471.13 Q 1260 1474.88 1255 1474.88 L 1252.5 1474.88 Q 1250 1474.88 1255 1474.88 L 1257.5 1474.88 Q 1260 1474.88 1260 1482.38 L 1260 1486.13 Q 1260 1489.88 1265 1489.88 L 1270 1489.88",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1260,1474.88)",
    pointerEvents: "all"
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 505 L 943.63 505",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 505 L 941.88 508.5 L 943.63 505 L 941.88 501.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 425 L 943.63 425",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 425 L 941.88 428.5 L 943.63 425 L 941.88 421.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 265 L 943.63 265",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 265 L 941.88 268.5 L 943.63 265 L 941.88 261.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 305 L 943.63 305",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 305 L 941.88 308.5 L 943.63 305 L 941.88 301.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g315 || (_g315 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 785 L 943.63 785",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 785 L 941.88 788.5 L 943.63 785 L 941.88 781.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g316 || (_g316 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 865 L 943.63 865",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 865 L 941.88 868.5 L 943.63 865 L 941.88 861.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g317 || (_g317 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 905 L 943.63 905",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 905 L 941.88 908.5 L 943.63 905 L 941.88 901.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g318 || (_g318 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-144"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 1295 L 943.63 1295",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.88 1295 L 941.88 1298.5 L 943.63 1295 L 941.88 1291.5 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g319 || (_g319 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 225 L 1111.63 224.84",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 224.84 L 1109.88 228.35 L 1111.63 224.84 L 1109.88 221.35 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g320 || (_g320 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-189"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 1295 L 1111.63 1294.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 1294.76 L 1109.9 1298.29 L 1111.63 1294.78 L 1109.86 1291.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g321 || (_g321 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 905 L 1111.63 904.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 904.76 L 1109.9 908.29 L 1111.63 904.78 L 1109.86 901.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g322 || (_g322 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 865 L 1111.63 864.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 864.76 L 1109.9 868.29 L 1111.63 864.78 L 1109.86 861.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g323 || (_g323 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 825 L 1111.63 824.76",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 824.75 L 1109.89 828.26 L 1111.63 824.76 L 1109.88 821.26 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g324 || (_g324 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 785 L 1111.63 784.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 784.76 L 1109.9 788.29 L 1111.63 784.78 L 1109.86 781.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g325 || (_g325 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-194"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 745 L 1111.63 744.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 744.76 L 1109.9 748.29 L 1111.63 744.78 L 1109.86 741.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g326 || (_g326 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-195"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 705 L 1111.63 704.76",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 704.75 L 1109.89 708.26 L 1111.63 704.76 L 1109.88 701.26 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g327 || (_g327 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 665 L 1111.63 664.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 664.76 L 1109.9 668.29 L 1111.63 664.78 L 1109.86 661.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g328 || (_g328 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 625 L 1111.63 624.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 624.76 L 1109.9 628.29 L 1111.63 624.78 L 1109.86 621.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g329 || (_g329 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-198"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 585 L 1111.63 584.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 584.76 L 1109.9 588.29 L 1111.63 584.78 L 1109.86 581.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g330 || (_g330 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-199"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 545 L 1111.63 544.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 544.76 L 1109.9 548.29 L 1111.63 544.78 L 1109.86 541.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g331 || (_g331 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 505 L 1111.63 504.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 504.76 L 1109.9 508.29 L 1111.63 504.78 L 1109.86 501.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g332 || (_g332 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 465 L 1111.63 464.76",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 464.75 L 1109.89 468.26 L 1111.63 464.76 L 1109.88 461.26 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 425 L 1111.63 424.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 424.76 L 1109.9 428.29 L 1111.63 424.78 L 1109.86 421.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g334 || (_g334 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-203"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 385 L 1111.63 384.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 384.76 L 1109.9 388.29 L 1111.63 384.78 L 1109.86 381.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900 345 L 1111.63 344.76",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 344.75 L 1109.89 348.26 L 1111.63 344.76 L 1109.88 341.26 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 305 L 1111.63 304.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 304.76 L 1109.9 308.29 L 1111.63 304.78 L 1109.86 301.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g337 || (_g337 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1070 265 L 1111.63 264.78",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.88 264.76 L 1109.9 268.29 L 1111.63 264.78 L 1109.86 261.29 Z",
    fill: "#f26d68",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g338 || (_g338 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-249"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 224.75 L 1281 225",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g339 || (_g339 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-250"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 264.75 L 1281 265",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g340 || (_g340 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-251"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 304.75 L 1281 305",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g341 || (_g341 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 344.75 L 1281 345",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g342 || (_g342 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 384.75 L 1281 385",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g343 || (_g343 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-255"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 424.75 L 1281 425",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g344 || (_g344 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 464.75 L 1281 465",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g345 || (_g345 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 504.75 L 1281 505",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g346 || (_g346 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 544.75 L 1281 545",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g347 || (_g347 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 584.75 L 1281 585",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g348 || (_g348 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-260"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 624.75 L 1281 625",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g349 || (_g349 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-261"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 664.75 L 1281 665",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g350 || (_g350 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 704.75 L 1281 705",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g351 || (_g351 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-263"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 744.75 L 1281 745",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g352 || (_g352 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-264"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 784.75 L 1281 785",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g353 || (_g353 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-265"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 824.75 L 1281 825",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g354 || (_g354 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-266"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 864.75 L 1281 865",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g355 || (_g355 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 904.75 L 1281 905",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g356 || (_g356 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 1254.75 L 1281 1255",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g357 || (_g357 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-281"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1238 1294.75 L 1281 1295",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g358 || (_g358 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-318"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 225 L 1430 225",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g359 || (_g359 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-319"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 265 L 1430 265",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g360 || (_g360 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 305 L 1430 305",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g361 || (_g361 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-321"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 345 L 1430 345",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g362 || (_g362 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-322"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 385 L 1430 385",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g363 || (_g363 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 425 L 1430 425",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g364 || (_g364 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-324"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 465 L 1430 465",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g365 || (_g365 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 505 L 1430 505",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g366 || (_g366 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 545 L 1430 545",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g367 || (_g367 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-327"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 585 L 1430 585",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g368 || (_g368 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-328"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 625 L 1430 625",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g369 || (_g369 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-329"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 665.15 L 1430 665",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g370 || (_g370 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 705 L 1430 705",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g371 || (_g371 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 745 L 1430 745",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g372 || (_g372 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 785 L 1430 785",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g373 || (_g373 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 825 L 1431.5 825",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g374 || (_g374 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-334"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 865 L 1431.5 865",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g375 || (_g375 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-335"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 905.36 L 1431.5 905",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g376 || (_g376 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1399 955 L 1430 955",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g377 || (_g377 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-337"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1399 1005 L 1430 1005",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g378 || (_g378 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-338"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1399 1055 L 1430 1055",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g379 || (_g379 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-339"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1399 1105 L 1430 1105",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g380 || (_g380 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-340"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1399 1155 L 1431.5 1154.75",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g381 || (_g381 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-341"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 1205 L 1431.5 1205",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g382 || (_g382 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-342"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 1255.36 L 1430 1255",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g383 || (_g383 = /*#__PURE__*/React.createElement("g", {
    id: "cell-AdwYpZ6ufbOx43SKG_LJ-343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 1295 L 1430 1295",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g384 || (_g384 = /*#__PURE__*/React.createElement("g", {
    id: "cell-ktDYASq-17bdOmyySLPw-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 810 L 1264 810 Q 1259 810 1259 817.5 L 1259 821.25 Q 1259 825 1254 825 L 1251.5 825 Q 1249 825 1254 825 L 1256.5 825 Q 1259 825 1259 832.5 L 1259 836.25 Q 1259 840 1264 840 L 1269 840",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,825)",
    pointerEvents: "all"
  }))), _g385 || (_g385 = /*#__PURE__*/React.createElement("g", {
    id: "cell-ktDYASq-17bdOmyySLPw-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 850 L 1264 850 Q 1259 850 1259 857.5 L 1259 861.25 Q 1259 865 1254 865 L 1251.5 865 Q 1249 865 1254 865 L 1256.5 865 Q 1259 865 1259 872.5 L 1259 876.25 Q 1259 880 1264 880 L 1269 880",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,865)",
    pointerEvents: "all"
  }))), _g386 || (_g386 = /*#__PURE__*/React.createElement("g", {
    id: "cell-ktDYASq-17bdOmyySLPw-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1269 890 L 1264 890 Q 1259 890 1259 897.5 L 1259 901.25 Q 1259 905 1254 905 L 1251.5 905 Q 1249 905 1254 905 L 1256.5 905 Q 1259 905 1259 912.5 L 1259 916.25 Q 1259 920 1264 920 L 1269 920",
    fill: "none",
    stroke: "#f26d68",
    strokeMiterlimit: 10,
    transform: "rotate(180,1259,905)",
    pointerEvents: "all"
  }))), _g387 || (_g387 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1240 1375 L 1281 1375",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g388 || (_g388 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1240 1424.92 L 1281 1425",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g389 || (_g389 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1240 1475.02 L 1279 1475.02",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g390 || (_g390 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1399 1475.02 L 1430 1475.02",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g391 || (_g391 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 1425 L 1431.5 1425",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g392 || (_g392 = /*#__PURE__*/React.createElement("g", {
    id: "cell-Fs1pSaefCXDkSIDEnMDA-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 1375 L 1431.5 1375",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  }))), _g393 || (_g393 = /*#__PURE__*/React.createElement("g", {
    id: "cell-iNM6wDF7hTtMBXn2YMH--4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1401 1335 L 1421 1335 L 1410 1335 L 1430 1335",
    fill: "none",
    stroke: "#cccccc",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  })))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentTestdrawio);
export default __webpack_public_path__ + "static/media/parent_test.drawio.6b1ea2ffbc02ff8d4884ff3c1ded5386.svg";
export { ForwardRef as ReactComponent };